import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { EndgamePage } from '../endgame/endgame';
import { Http } from '@angular/http';
import { DomSanitizer } from '@angular/platform-browser';
import { Events } from 'ionic-angular';
import { ToastController } from 'ionic-angular';
import { Auth } from '../../providers/auth';

import introJs from 'intro.js/intro.js';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { SmartAudio } from '../../providers/smart-audio';
import { UserdataModel } from '../../providers/userdata-model';
import { GameModel } from '../../providers/game-model';
import { GamerulesModel } from '../../providers/gamerules-model';
import { DataExchanger } from '../../providers/data-exchanger';
import { ThermometerBarComponent } from '../../components/thermometer-bar/thermometer-bar';

//import easeljs from '../../assets/js/easeljs';
//import createjs from '../../assets/js/createjs';
//import * as easeljs from 'createjs-easeljs';
//import easeljs from 'createjs-easeljs';
//import createjs from 'createjs';
//import plus1 from '../../assets/js/plus1';

@Component({
  selector: 'page-play',
  templateUrl: 'play.html',
  host: { '(window:resize)': 'handleResizeEvents($event)', '(document:keydown)': 'handleKeyboardEventsKeyDown($event)', '(document:keyup)': 'handleKeyboardEventsKeyUp($event)' }
})

export class PlayPage {
  @ViewChild('showntextscroll') private showntextscroll: ElementRef;
  socket = this.functions.getSocket(); //Get socket
  userInfo: Object; //obj with current user info
  private scrollElement;
  instext: string;
  showntext: string;
  shiftOn: boolean;

  introJsVar: any;
  tutorialMessages: string[] = [];
  tutorialIdElement: string[] = [];
  tutorialPosition: string[] = [];

  textblocks = [];
  wholetext: string;
  numElementsToPlay: number;
  numSntTotalBook: number;
  textToShowPriorOrPosterior: string;
  lastSntToConsiderIndex: number;
  numSntToSkipInThisRound: number = 0;

  // In Classic mode is the number of sentence (Bookmark)
  // In Shannon mode is number of the character inside the sentence (bookmarkLetter)
  indexElementToGuessInThisRound: number = 0;

  round: number;
  attempt: number;
  scorePartial: number;        // score of the current game withour bonus
  scoreFinalBonuses: number;  // bonus to score, see endgame
  scoreFinalChallenger: number;
  timeFinalChallenger: number;
  entropyFinalChallenger: number;
  numSbagliate: number;
  numCorrette: number;
  currentBookmarkLetter: number;
  bookmarkLetterAtGameBegin: number;
  currentChunk: number;
  currentChunkProgress: number;
  currentChunkStart: number;
  currentChunkEnd: number;
  currentChunkTotalChar: number;
  currentChunkScoreAtGameBegin: number;
  numChunksInBook: number;
  currentLevel: number;
  currentLevelProgress: number;
  currentScoreChallenger: number = 0;
  currentThermometerProgress: number;
  currentThermometerColor: string;
  currentBlinkingCursorColor: string = "green";
  currentColorCatVersus: string;
  chunkCharSkippedAtBeginningOrEndOfBook: number;
  finalEntropyValues = [];
  numLettersGuessedInCurrentChunkAtGameBegin: number;
  priorOrPosteriorIndexes = [];
  wasGameModeVersus: boolean;
  wasGameModeVersusPVPAsync: boolean;
  wasGameModeVersusPVPSync: boolean;
  wasGameModeKids: boolean;
  savedSettingsBeforeVersusGame = [];
  tutorialIsRunning: boolean;
  initialBonusGave: boolean;

  splitInSntTotal: string[] = [];
  splitInSnt: string[] = [];

  pauseInteractionWithKeyboard: boolean;
  time: number;
  timeFinal: number;

  isGameEndedBoolean: boolean;

  mood: string;

  randomGameBg: string;

  refreshIntervalId;
  refreshVersusIntervalId;
  pauseAnimationIntervalId;

  currentKeyboard: number;

  // ad es, if I have keyboard 0 1 2 and 3 this is 4
  numKeyboardsAvailable: number;
  numLettersInSingleKeyboards: number;

  keyboards = {
    'en': {},
    'it': {}
  };

  // Last 'false' is for space button
  letterTriedInThisRound = {
    0: [false, false, false, false, false, false, false, false, false, false, false,
      false, false, false, false, false, false, false, false, false, false, false,
      false, false, false, false, false, false, false, false, false, false, false,
      false],
    1: [false, false, false, false, false, false, false, false, false, false, false,
      false, false, false, false, false, false, false, false, false, false, false,
      false, false, false, false, false, false, false, false, false, false, false,
      false],
    2: [false, false, false, false, false, false, false, false, false, false, false,
      false, false, false, false, false, false, false, false, false, false, false,
      false, false, false, false, false, false, false, false, false, false, false,
      false]
  }

  initialGameDataForVersus; // data coming from server
  initialGameDataForVersusSync; // data coming from socket
  challengerGameDataVersus; // elaborated data
  challengerCurrentAttempt; // holds the current attempt of the challenger in time
  guidUserVersus;
  idGameVersus;
  minBookmarkReachedChallenger; // minimun index bookmark reached by challenger during his game
  maxBookmarkReachedChallenger;

  // This array is something like [ [[1,2],[1,4]] , [[1,3]] ]
  /* Contains one element Z for each character playable in the current game (this.getSlicedTextblockToGuess().length)
  and a couple [X,Y] for each character Z with index Y and keyboard X in array letterTriedInThisRound tried in the previuos rounds
  As you move the cursor, the array letterTriedInThisRound is rebuilded according to listOfLetterTriedInThisRound content
  Is used in classical mode and in hangman, for, even in classic mode, there is need to remember letter guessed wrong in previous games
  */
  listOfLetterTriedInThisRound = [];

  // boolean array el[i] (i=0 to N)
  // i corrispond to i element of slicedTextblock, is a number M equal to the attempt wrong done on i letter
  maxAttemptsWrong = [];

  // boolean array el[i] (i=0 to N)
  // i corrispond to i element of between startBookmark and endBookmark given in getMaxAttemptsTotal, is a number M equal to the attempt done on i letter (wrong+1 if guessed right)
  maxAttemptsTotal = [];

  // number array el[i] (i=0 to N)
  // i corrispond to i element of slicedTextblock, is true or false if i letter was guessed before or not
  lettersGuessedOrNotHangman: boolean[];

  // object array el[i] (i=0 to N with max elements of current chunk)
  // i corrispond to i element of current chunk, is a object containing data par for character i in chunk
  // It is NOT going with slicedTextblock for the last element of any chunk doesn't have a record for par
  parsOfTextblock = [];

  // el[i] is true if character i was guessed right by challenger during this game playback at the current time
  lettersGuessedOrNotHangmanVersusChallenger;
  fartherIndexDashReachedDuringGame = -1;

  currentGuessableString: string = "";
  showablecurrentGuessableString;

  //Socket vars
  imIngame: boolean = true; //Check if the current player is in game
  otherPlayerInGame: boolean = true; //Check if other player is in game
  disconnectedMsg: string = "pvp_score_msg" //Dynamic message disconnection pvp
  otherPlayerScore: any //Dynamic score other player
  otherPlayerUsername: object = {} //Dynamic score other player
  myPvpendGame: boolean = false;
  otherPvpendGame: boolean = false;
  userDisconnected: boolean = false;
  savedGameObj: object = {
    userguid: this.userdataModel.getGuidUser(),
    savedgame: false
  }
  otherPlayerSavedGame: boolean = false;
  constructor(public functions: Functions, public http: Http, public auth: Auth, public rubedoSideMenu: MenuController, public toastCtrl: ToastController, public translate: TranslateService, public events: Events, public ThermometerBar: ThermometerBarComponent, public userdataModel: UserdataModel, public navCtrl: NavController, public playModel: GameModel, public gamesrulesModel: GamerulesModel, public smartAudio: SmartAudio, public dataExchanger: DataExchanger, public sanitizer: DomSanitizer) {

    //Socket user info
    this.userInfo = {
      guidUser: this.userdataModel.getGuidUser(),
      username: this.userdataModel.getUsername(),
      idGame: "",
      actions: ""
    }

    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(false, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(false);

    this.introJsVar = introJs.introJs();
    this.mood = 'clueless';

    for (let i = 0; i < Object.keys(this.functions.allKeyboards.en).length; i++) {
      this.keyboards['en'][i] = this.functions.allKeyboards.en[this.functions.keyboardsActuallyInUse.en[i]];
    }
    for (let i = 0; i < Object.keys(this.functions.allKeyboards.it).length; i++) {
      this.keyboards['it'][i] = this.functions.allKeyboards.it[this.functions.keyboardsActuallyInUse.it[i]];
    }

    //Check socket only for pvpsync
    if (this.functions.isGameModeVersusPVPSync()) {
      console.log('@ IN PVP MODE')
      var that = this;

      //Socket listner, this get initial data of players and begin game
      this.socket.on('sendData', function (data) { // get data other user
        that.initialGameDataForVersusSync = data;
        console.log('@ START PVP GAME')

        //we need to remove socket listener after the first call, this is to avoid multiple call on stack view
        that.socket.removeAllListeners("sendData");
        that.begingame();

      });

      //Socket listner, this get game data of the players, (key press event etc.)
      this.socket.on('sendplayerData', function (playerData) { 
        that.challengerGameDataVersus.push(playerData);
      });

      //Socket listner, this get status of the players when the game end
      this.socket.on('end game', function (status) { 
        console.log("@ end game")
        that.otherPvpendGame = status;
        //we need to remove socket listener after the first call, this is to avoid multiple call on stack view
        that.socket.removeAllListeners("end game");
      });


      //Socket listner, set local var to check if other user end game before a disconnection event
      this.socket.on('SavedGame', function (obj) { 
        console.log("@ SavedGame")
        if (obj.savedgame) {
          that.otherPlayerSavedGame = true;
        }
        //we need to remove socket listener after the first call, this is to avoid multiple call on stack view
        that.socket.removeAllListeners("SavedGame");
      });

      //Socket listner, check the players disconnection event
      this.socket.on('playerDisconnected', function (disconnectionObj) {
        console.log("@ playerDisconnected")
        //Check if other user end game before the disconnection event
        if (!that.otherPlayerSavedGame) {
          that.otherPlayerUsername = { username: disconnectionObj.username }
          that.userDisconnected = true;
          that.disconnectedMsg = "pvp_score_msg_disconnected"; //Set disconnection message
          
          //Update data and show notification only if the player is out of game
          if (!that.myPvpendGame && !that.otherPvpendGame) {
            if (!that.imIngame) {
              //console.log("ok, im not in game, alert")
              that.dataExchanger.setDataGameWinVersusPVPAsync(
                that.playModel.getCurrentGameId(),
                that.userdataModel.getGuidUser(),
                "win_versus_for_disconnection").then((response) => {
                  //console.log("MY Player WIN for disconnection!")
                  that.functions.showMessagePVP(that.toastCtrl, that.disconnectedMsg, "empty_string", that.otherPlayerUsername, 4000, "toastMessage toastMessageAchievement toastMessagePVP");

                });
            }
          }

        }
        //we need to remove socket listener after the first call, this is to avoid multiple call on stack view
        that.socket.removeAllListeners("playerDisconnected");
      })

      //Socket listner, takes player data and sets a local variable that will be used for future calculation of the final score
      this.socket.on('getDataScore', function (score) {
        console.log("@ getDataScore")
        that.otherPlayerScore = score; //Store score in local var
        that.otherPlayerUsername = { username: score.username }
         if (!that.imIngame) {
          //console.log("ok, im not in game, alert")
          that.functions.showMessagePVP(that.toastCtrl, that.disconnectedMsg, "empty_string", that.otherPlayerUsername, 4000, "toastMessage toastMessageAchievement toastMessagePVP");
        }
        else {
          console.log("@ I'm in game, wait")
        }

        that.otherPlayerInGame = false;

        //we need to remove socket listener after the first call, this is to avoid multiple call on stack view
        that.socket.removeAllListeners("getDataScore");
      })

    }

  }

  /* --------- LIFECYCLE --------- */
  ionViewDidLoad() {
    //this.showntextRef.nativeElement.style.color = "red";
    //this.showntextRef.nativeElement.style.width = this.round+'px';
  }

  ionViewWillEnter() {
    // before the page in question becomes active
    // remove menu
    if (document.getElementById('sideMenuButton')) {
      document.getElementById('sideMenuButton').style.display = 'none';
    }
    //document.getElementById('skip').style.cssText='width:48% !important';
    this.functions.changeShowSidemenuButtonTo(this.functions.sidemenuEnabled);
    this.functions.stopBgMusic('app_BgMusic');
    this.randomGameBg = this.functions.getRandomGameBg();
    this.functions.startBgMusic(this.randomGameBg);
    this.setKeyboardsSizes();
    //this.setShiftStatus(false);

    //Socket Call, send user info data to other player only for pvp sync
    if (this.functions.isGameModeVersusPVPSync()) {
      this.userInfo["idGame"] = this.playModel.getNewGameId();
      this.socket.emit('sendData', this.userInfo);
    }
    else { //For Other game mode start game
      this.begingame();
    }
  }

  ionViewWillLeave() {
    //before the page leaves the viewport
    //document.getElementById('sideMenuButton').style.display='block'; //This is commented to avoid flash of the menu reapperaing and disappearing in endgame page 
    if (this.wasGameModeKids || this.wasGameModeVersus || this.wasGameModeVersusPVPAsync || this.wasGameModeVersusPVPSync) {
      this.restoringSettingsAfterGameVersus();
      /* this is not truly necessary but at this point some functions variable got lost, showing the former value,
           for some reason I don't know. Debug showed it happens inside http...subscribe */
    }

    this.functions.setGameMode();
    this.functions.setLanguage();

    // Update Array of Sync and Async Games
    this.dataExchanger.getVersusPVPSyncGames().then((response) => {});
    this.dataExchanger.getVersusPVPAsyncGames().then((response) => {});

    this.introJsVar.exit(); // if we are leaving the play page and the intro is active, close it
  }

  ionViewDidEnter() {
    this.functions.setScaleForBigScreen();
    //after the page in question becomes active
    //console.log(this.showntextscroll.nativeElement.scrollHeight);
    this.scrollOnFocusText();

    //console.log("++++ this.playModel.getNumGamesPlayed(): "+this.playModel.getNumGamesPlayed() );
    if (this.playModel.getNumGamesPlayed() <= this.functions.numMaxGamesDisplayWalktroughtMsg
      && !this.functions.isBigScreen()
      && !this.functions.isRunningOnIos()) {
      this.functions.showWalkthroughWithMessageWithButtons("fullscreenMsg_1", "superhappy");
      document.getElementById("start_tutorial_yes").addEventListener("click", () => { this.functions.hideWalkthrough(); this.startTutorial(); })
    }
  }

  ionViewDidLeave() {
    //after the page leaves the viewport
  }

  ionViewWillUnload() {
    //before the page is removed from the DOM
  }
  /* --------- END LIFECYCLE --------- */

  /* --------- FUNCTIONS --------- */
  ngDoCheck() {
    // zozzata: faccio scrollare giù ogni volta che il tempo passato è multiplo di tot così 
    // l'utente può guardare il testo tra 0 e tot secondi
    // idem faccio scrollare per un paio di secondi dopo che è stato fatto uno skip
    // o un indovina sennò scendeva fino all'altezza della frase precedente (non faceva in tempo ad
    // apparire la frase dopo allungando l'altezza della finestra


    //TODO riabilitare scroll?
    /*
    var haskippedorguessedplus=this.haskippedorguessed-2;
    if(this.time%15==0 
      || this.time>=haskippedorguessedplus){
        this.scrollOnFocusText();
    }*/
  }

  handleResizeEvents(event: KeyboardEvent) {
    if (this.tutorialIsRunning) {
      // This line force the tutorial to reload on resize to position it correctly
      this.introJsVar.start().goToStep(1);
    }
    
    this.functions.setScaleForBigScreen();
  }

  tryWord() {
    var scoreEarned;

    if (this.functions.isGameModeShannon()) {
      this.setLetterTried(this.getIndexInKeyboards(this.instext, "allKeyboards", "returnAllIndexes", "changeKeyboardWithIndexFound"), -1);
    }

    // Guessed right
    if (this.functions.normalizeForComparison(this.instext) == this.functions.normalizeForComparison(this.getElementToGuess())) {
      console.log("wordProposed:|" + this.functions.normalizeForComparison(this.instext) + "|" + "  wordToGuess:|" + this.functions.normalizeForComparison(this.getElementToGuess()) + "|" + "Try Result: RIGHT");

      this.functions.play('claps');

      this.lettersGuessedOrNotHangman[this.getIndexInSlicedArray(this.currentBookmarkLetter)] = true;

      scoreEarned = this.gamesrulesModel.calculateScore(this.maxAttemptsWrong[this.getIndexInSlicedArray(this.currentBookmarkLetter)] + 1, this.getParOfBookmark(this.currentBookmarkLetter));
      this.storeWordData(true, scoreEarned);
      /*if(this.mood=='happy'){
        this.mood='superhappy';
      }else{
        this.mood='happy';
      }*/

      //console.log("ADDING TO SCORE: "+scoreEarned);
      this.scorePartial = this.scorePartial + scoreEarned;
      this.currentLevel = this.gamesrulesModel.getLevelFromScore(this.userdataModel.getScore() + this.scorePartial);
      this.currentLevelProgress = this.gamesrulesModel.getProgressInLevelFromScore(this.userdataModel.getScore() + this.scorePartial);

      this.numCorrette++;
      this.updateCurrentChunkProgress();

      /* -------- SETTING TROPHIES -------- */
      // Number of letters guessed
      var quantityArray = this.gamesrulesModel.getQuantityArrayForCollectibleId(this.gamesrulesModel.getCollectibleIdFromShortname("chars_guessed"));
      var numCharsGuessedInGamemodeCategoryALL = this.userdataModel.getNumTotalCharsGuessedInGamemodeCategory('all') + this.numCorrette;
      for (let i = 0; i < quantityArray.length; i++) {
        if (numCharsGuessedInGamemodeCategoryALL >= parseInt(quantityArray[i])) {
          if (this.userdataModel.setCollectibleGot(this.gamesrulesModel.getCollectibleIdFromShortname("chars_guessed"), quantityArray[i], this.gamesrulesModel.getIsglobalforanybookForCollectibleId(this.gamesrulesModel.getCollectibleIdFromShortname("chars_guessed")))) {
            this.functions.showMessageTranslatedAchievement(this.toastCtrl, "msg_got_achievement", "chars_guessed_achievement_" + quantityArray[i]);
            console.log(quantityArray[i] + " CHARS GUESSED!  Achievement Set");
          }
        }
      }
      /* -------- END --- SETTING TROPHIES -------- */

      //this.time=this.time+5;

      this.changeRound();
      this.updateThermometer(this.currentBookmarkLetter);
      //Guessed Wrong
    } else {
      console.log("wordProposed:|" + this.functions.normalizeForComparison(this.instext) + "|" + "  wordToGuess:|" + this.functions.normalizeForComparison(this.getElementToGuess()) + "|" + "Try Result: WRONG");
      if (this.functions.isGameModeShannon()) {
        this.animateButtonClicked('key_' + this.getIndexInKeyboards(this.instext, "currentKeyboard", "returnSingleIndex", "changeKeyboardWithIndexFound"), 'colorred');
        this.pauseInteractionWithKeyboard = true;

        this.pauseAnimationIntervalId = setInterval(() => {
          this.pauseInteractionWithKeyboard = false;
          clearInterval(this.pauseAnimationIntervalId);
        }, 0);
      }

      this.updateThermometer(this.currentBookmarkLetter);

      this.maxAttemptsWrong[this.getIndexInSlicedArray(this.currentBookmarkLetter)]++;
      this.updateCurrentGuessableString();

      this.functions.play('kitten_meow');
      this.storeWordData(false, 0);

      this.numSbagliate++;
      this.numCorrette;
    }

    //Socket Call, send data to players every time a key is pressed (only for pvp mode)
    if (this.functions.isGameModeVersusPVPSync()) {
      var playerData = this.getFormattedWordtypedForPlaybackArray(this.playModel.getFirstWordtyped(), this.playModel.getLastWordtyped());
      console.log('@ try pvp word')
      this.socket.emit('sendplayerData', playerData); //the get is in the sendplayerData socket listner
    }

    this.instext = '';
    this.attempt++;
  }

  getTimesWasPlayedInthisGamemode(){
    var timesWasPlayed=1;
    if (!this.functions.isGameModeVersus() && !this.functions.isGameModeVersusPVPSync() && !this.functions.isGameModeVersusPVPAsync() ) {
      timesWasPlayed=this.userdataModel.getTimesWasPlayed();
    }else{
      if (this.functions.isGameModeVersus()) {
        timesWasPlayed=this.initialGameDataForVersus[0].timesWasPlayed;
      }
      if (this.functions.isGameModeVersusPVPSync() || this.functions.isGameModeVersusPVPAsync() ) {
        timesWasPlayed=this.functions.getTimesWasPlayedPVP();
      }
    }
    return timesWasPlayed;
  }

  storeWordData(correct, scoreEarned) {
    this.playModel.addWord(
      this.functions.getIdCurrentBook(),
      this.playModel.getCurrentGameId(),
      this.round, //round
      this.attempt, //attempt
      this.currentBookmarkLetter, //currentBookmarkLetter
      this.time, //time
      this.functions.currentTimestamp(), //tsInsert
      this.instext, //word
      this.getElementToGuess(), //wordToGuess
      correct, // isCorrect
      scoreEarned, // scoreEarned
      this.maxAttemptsWrong[this.getIndexInSlicedArray(this.currentBookmarkLetter)], //attemptsWrong
      this.getTimesWasPlayedInthisGamemode()
    );
  }

  getFormattedWordtypedForPlaybackArray(firstWordtyped, lastWordtyped) {

    /*console.log("YYYYY firstWordtyped: "+JSON.stringify(firstWordtyped));
    console.log("YYYYY lastWordtyped: "+JSON.stringify(lastWordtyped));

    console.log("YYYYY firstWordtyped TS: "+JSON.stringify(this.convertTimestamp(firstWordtyped.tsInsert)));
    console.log("YYYYY lastWordtyped TS: "+JSON.stringify(this.convertTimestamp(lastWordtyped.tsInsert)));

    console.log("YYYYY DIFF TS: "+(this.convertTimestamp(lastWordtyped.tsInsert) - this.convertTimestamp(firstWordtyped.tsInsert)));*/

    var wordtypedFormatted = {
      time: this.convertTimestamp(lastWordtyped.tsInsert) - this.convertTimestamp(firstWordtyped.tsInsert),
      bookmarkLetter: lastWordtyped.bookmarkLetter,
      isCorrect: lastWordtyped.isCorrect,
      attempt: lastWordtyped.attempt,
      score: lastWordtyped.scoreEarned
    };

    return wordtypedFormatted;
  }

  storeFinalGameData(typeOfwin) {
    console.log("TYPE OF PVP WIN " + typeOfwin);
    var idGame = this.playModel.getCurrentGameId();
    console.log("SAVE THIS GAME: " + idGame)
    this.playModel.setTsEndgame(idGame, this.functions.currentTimestamp());
    this.playModel.setScoreFinal(idGame, this.userdataModel.getScore());
    this.playModel.setLevelFinal(idGame, this.gamesrulesModel.getLevelFromScore(this.userdataModel.getScore()));
    this.playModel.setBookmarkLetterFinal(idGame, this.currentBookmarkLetter);
    this.playModel.setIdChunkInBookFinal(idGame, this.currentChunk);
    this.playModel.setFartherIndexDashReachedDuringGame(idGame, this.fartherIndexDashReachedDuringGame + this.getBeginSlicedTexblock());
    this.playModel.setNumCorrette(idGame, this.numCorrette);
    this.playModel.setNumSbagliate(idGame, this.numSbagliate);
    this.playModel.setWin(idGame, typeOfwin);
    if (this.timeFinal == -1) { this.timeFinal = this.time; }
    this.playModel.setTimeFinal(idGame, this.timeFinal);
    this.playModel.storeGamesData();
    this.dataExchanger.setDataGameAcceptedInGameSentVersusPVPAsync(this.functions.getIdGameSentVersusPVPAsync(), this.functions.getGuidChallengerPvpAsync(), idGame).then((response) => { });

    return new Promise((resolve) => {
      this.dataExchanger.storeUserGamedataOnServer(false).then((response) => {
        this.dataExchanger.storeGamedataOnServer().then((response) => {
          resolve();
        });
      });
    });
  }

  storeFinalEntropyGameData() {
    var idGame = this.playModel.getCurrentGameId();

    this.playModel.setDownEntropy(idGame, this.finalEntropyValues[0]);
    this.playModel.setUpEntropy(idGame, this.finalEntropyValues[1]);

    return new Promise((resolve) => {
      this.dataExchanger.storeUserGamedataOnServer(false).then((response) => {
        this.dataExchanger.storeGamedataOnServer().then((response) => {
          resolve();
        });
      });
    });
  }

  timer() {
    this.refreshIntervalId = setInterval(() => {
      // Was time--
      if (!this.isGameEndedBoolean && !this.tutorialIsRunning) {
        this.time++;
      }

      /*if(this.time==10 || this.time==5){ 
        this.functions.play('tick_tock');
        this.mood='fear'; 
      }*/
      if (this.time == 0) {
        this.endgame("end_classic");
      }
    }, 1000);
  }

  endgame(typeOfwin) {
    var chunkFinished;

    if (!this.isGameEndedBoolean) { // just not to allow endgame to fire twice
      // isGameEndedBoolean also stops time from ticking so not to add the take a breath second to time consumed during the game
      this.isGameEndedBoolean = true;
      this.pauseInteractionWithKeyboard = true;
      chunkFinished = false;

      // take a breath and go on (time for the player to see its last action)
      setTimeout(() => {
        this.updateIndexesAndBookmark(true);
        var idChunkInBookAtGameEnd = this.currentChunk;
        this.scoreFinalBonuses = 0;

        /* --- ADDING BONUSES to score -- */
        if (!this.functions.isGameModeShannonReverse()
          && this.currentBookmarkLetter > this.gamesrulesModel.getChunkEnd(this.functions.getIdCurrentBook(), this.currentChunk)) {
          this.scoreFinalBonuses = this.scoreFinalBonuses + this.functions.bonusScore['chunkFinished'];
        }
        if (this.functions.isGameModeShannonReverse()
          && this.currentBookmarkLetter < this.gamesrulesModel.getChunkStart(this.functions.getIdCurrentBook(), this.currentChunk)) {
          this.scoreFinalBonuses = this.scoreFinalBonuses + this.functions.bonusScore['chunkFinished'];
        }
        /* --- END ---- ADDING BONUSES to score -- */

        if (!this.functions.isGameModeVersus() && !this.functions.isGameModeVersusPVPAsync() && !this.functions.isGameModeVersusPVPSync()) {
          // Check if chunk is finished and update 
          // If chunk is finshed update chunk (+1 or -1 for classic or reverse mode) and time/progress/score starts from zero again

          this.userdataModel.setCurrentTime(this.time);
          this.userdataModel.setCurrentNumLettersGuessedInCurrentChunk(this.numLettersGuessedInCurrentChunkAtGameBegin + this.numCorrette);
          // there are bonus if chunk finished and in that case score is 0 so we don't add final bonuses. This must rethought if other bonus are applied
          this.userdataModel.setCurrentChunkScore(this.currentChunkScoreAtGameBegin + this.scorePartial);

          if (!this.functions.isGameModeShannonReverse()
            && this.currentBookmarkLetter > this.gamesrulesModel.getChunkEnd(this.functions.getIdCurrentBook(), this.currentChunk)) {
            chunkFinished = true;

            this.currentChunk = this.getNextChunk(this.currentChunk);
            this.userdataModel.setCurrentTime(0);
            this.userdataModel.setCurrentNumLettersGuessedInCurrentChunk(0);
            this.userdataModel.setCurrentChunkScore(0);
          }
          if (this.functions.isGameModeShannonReverse()
            && this.currentBookmarkLetter < this.gamesrulesModel.getChunkStart(this.functions.getIdCurrentBook(), this.currentChunk)) {
            chunkFinished = true;

            this.currentChunk = this.getNextChunk(this.currentChunk);
            this.userdataModel.setCurrentTime(0);
            this.userdataModel.setCurrentNumLettersGuessedInCurrentChunk(0);
            this.userdataModel.setCurrentChunkScore(0);
          }

          this.userdataModel.setCurrentIdChunkInBook(this.currentChunk);

          this.userdataModel.setBookmarkLetter(this.currentBookmarkLetter);
          this.currentLevel = this.gamesrulesModel.getLevelFromScore(this.userdataModel.getScore() + this.scorePartial + this.scoreFinalBonuses);
          this.currentLevelProgress = this.gamesrulesModel.getProgressInLevelFromScore(this.userdataModel.getScore() + this.scorePartial + this.scoreFinalBonuses);
        } else {
          // Versus mode    
          if (this.functions.isGameModeVersusPVPAsync()) {
            typeOfwin = "";
          }

          if (this.functions.isGameModeVersus() || (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameAcceptedVersusPVPAsync())) {
            if ((this.scorePartial >= this.scoreFinalChallenger) || ((this.functions.isGameModeVersusPVPAsync() && this.functions.isGameAcceptedVersusPVPAsync()) && (this.scorePartial == this.scoreFinalChallenger && this.timeFinal <= this.timeFinalChallenger))) {
              typeOfwin = "win_versus";
              console.log("SETTING lost_versus getIdGameSentVersusPVPAsync: " + this.functions.getIdGameSentVersusPVPAsync() + " getGuidChallengerPvpAsync: " + this.functions.getGuidChallengerPvpAsync());
              this.dataExchanger.setDataGameWinVersusPVPAsync(this.functions.getIdGameSentVersusPVPAsync(), this.functions.getGuidChallengerPvpAsync(), "lost_versus").then((response) => { console.log("SETTING lost_versus OK"); });
              chunkFinished = true;
            } else {
              typeOfwin = "lost_versus";
              console.log("SETTING win_versus getIdGameSentVersusPVPAsync: " + this.functions.getIdGameSentVersusPVPAsync() + " getGuidChallengerPvpAsync: " + this.functions.getGuidChallengerPvpAsync());
              this.dataExchanger.setDataGameWinVersusPVPAsync(this.functions.getIdGameSentVersusPVPAsync(), this.functions.getGuidChallengerPvpAsync(), "win_versus").then((response) => { console.log("SETTING win_versus OK"); });
            }
          }
        }

        if (chunkFinished) {
          this.userdataModel.setNumchunkcompleted(this.userdataModel.getNumchunkcompleted() + 1);
        }
        if (!this.functions.isGameModeVersus() && !this.functions.isGameModeVersusPVPAsync()) {
          // makes no sense for versus since we pick a random chunk, is not sequential
          this.userdataModel.setNumcharskippedatbeginning(this.functions.numCharacterPriorOrPosterior);
          if (!this.functions.isGameModeShannonReverse()) {
            // If the first playable is chunk 0 we skipped 0 chunks, if it is 1 we skipped 1 chunk (chunk 0) and so on 
            this.userdataModel.setNumchunkskippedatbeginning(this.getFirstChunkPlayableOfBook());
          } else {
            /* -1 for numchunktotal is a number starting from 1, firstchunkplayable is an id starting from 0
            If the first playable is chunk 302, and we have 304 (0-303) chunks we skipped 1 chunks, if it is 303 we skipped 0 chunk and so on */
            this.userdataModel.setNumchunkskippedatbeginning((this.userdataModel.getNumchunktotal() - 1) - this.getFirstChunkPlayableOfBook());
          }
        }

        this.userdataModel.setNumcharguessed(this.userdataModel.getNumcharguessed() + this.numCorrette);
        this.userdataModel.setNumgamesplayed(this.userdataModel.getNumgamesplayed() + 1);

        if (typeOfwin == "win_versus") {
          this.userdataModel.setNumgameswon(this.userdataModel.getNumgameswon() + 1);
        }

        this.userdataModel.setScore(this.userdataModel.getScore() + this.scorePartial + this.scoreFinalBonuses);
        this.userdataModel.setLevel(this.gamesrulesModel.getLevelFromScore(this.userdataModel.getScore() + this.scorePartial + this.scoreFinalBonuses));


        /* -------- SETTING TROPHIES -------- */
        //console.log("CollectiblesGOT BEF: "+JSON.stringify(this.userdataModel.getCollectiblesGot()));

        // Trophies messages are put inside an array to show them in succession
        var trophiesMessagesArray = [];
        var quantityArray;

        if (!this.functions.isGameModeVersus() && !this.functions.isGameModeVersusPVPAsync() && !this.functions.isGameModeVersusPVPSync()) {

          // First fragment of book completed
          console.log("this.getFirstChunkPlayableOfBook(): " + this.getFirstChunkPlayableOfBook());
          if ((!this.functions.isGameModeShannonReverse() && this.currentChunk == this.getFirstChunkPlayableOfBook() + 1)
            || (this.functions.isGameModeShannonReverse() && this.currentChunk == this.getFirstChunkPlayableOfBook() - 1)
          ) {
            // set achievement book beginned
            if (this.userdataModel.setCollectibleGot(this.gamesrulesModel.getCollectibleIdFromShortname("book_first_chunk"), 0, this.gamesrulesModel.getIsglobalforanybookForCollectibleId(this.gamesrulesModel.getCollectibleIdFromShortname("book_first_chunk")))) {
              trophiesMessagesArray.push("book_first_chunk_achievement_" + this.functions.getIdCurrentBook());
              console.log("BOOK BEGINNED! Achievement Set");
            }
          }

          // Book ended
          if (this.userdataModel.isBookComplete(this.functions.getIdCurrentBook())) {
            // set achievement book completed
            if (this.userdataModel.setCollectibleGot(this.gamesrulesModel.getCollectibleIdFromShortname("book_completed"), 0, this.gamesrulesModel.getIsglobalforanybookForCollectibleId(this.gamesrulesModel.getCollectibleIdFromShortname("book_completed")))) {
              trophiesMessagesArray.push("book_completed_achievement_" + this.functions.getIdCurrentBook());
              console.log("BOOK COMPLETED! Achievement Set");
            }
          }
        } else {
          var numTotalGamesPlayed;
          var numTotalGamesWon;

          // PVP games completed
          quantityArray = this.gamesrulesModel.getQuantityArrayForCollectibleId(this.gamesrulesModel.getCollectibleIdFromShortname("pvp_game_played"));
          numTotalGamesPlayed = this.userdataModel.getNumTotalGamesPlayedInGamemodeCategory('pvp');
          //console.log("++++++ numTotalGamesPlayed PVP: "+numTotalGamesPlayed);
          for (let i = 0; i < quantityArray.length; i++) {
            if (numTotalGamesPlayed >= quantityArray[i]) {
              if (this.userdataModel.setCollectibleGot(this.gamesrulesModel.getCollectibleIdFromShortname("pvp_game_played"), quantityArray[i], this.gamesrulesModel.getIsglobalforanybookForCollectibleId(this.gamesrulesModel.getCollectibleIdFromShortname("pvp_game_played")))) {
                trophiesMessagesArray.push("pvp_game_played_achievement_" + quantityArray[i]);
                console.log(quantityArray[i] + " PVP GAMES COMPLETED! Achievement Set");
              }
            }
          }

          // PVP games won
          quantityArray = this.gamesrulesModel.getQuantityArrayForCollectibleId(this.gamesrulesModel.getCollectibleIdFromShortname("pvp_game_won"));
          numTotalGamesWon = this.userdataModel.getNumTotalGamesWonInGamemodeCategory('pvp');
          //console.log("+++++++ numTotalGamesWon PVP: "+numTotalGamesWon);
          for (let i = 0; i < quantityArray.length; i++) {
            if (numTotalGamesWon >= quantityArray[i]) {
              if (this.userdataModel.setCollectibleGot(this.gamesrulesModel.getCollectibleIdFromShortname("pvp_game_won"), quantityArray[i], this.gamesrulesModel.getIsglobalforanybookForCollectibleId(this.gamesrulesModel.getCollectibleIdFromShortname("pvp_game_won")))) {
                trophiesMessagesArray.push("pvp_game_won_achievement_" + quantityArray[i]);
                console.log(quantityArray[i] + " PVP GAMES WON! Achievement Set");
              }
            }
          }

          // versusAI games completed
          quantityArray = this.gamesrulesModel.getQuantityArrayForCollectibleId(this.gamesrulesModel.getCollectibleIdFromShortname("ai_game_played"));
          numTotalGamesPlayed = this.userdataModel.getNumTotalGamesPlayedInGamemodeCategory('versusAI');
          //console.log("+++++++ numTotalGamesPlayed versusAI: "+numTotalGamesPlayed);
          for (let i = 0; i < quantityArray.length; i++) {
            if (numTotalGamesPlayed >= quantityArray[i]) {
              if (this.userdataModel.setCollectibleGot(this.gamesrulesModel.getCollectibleIdFromShortname("ai_game_played"), quantityArray[i], this.gamesrulesModel.getIsglobalforanybookForCollectibleId(this.gamesrulesModel.getCollectibleIdFromShortname("ai_game_played")))) {
                trophiesMessagesArray.push("ai_game_played_achievement_" + quantityArray[i]);
                console.log(quantityArray[i] + " versus AI GAMES COMPLETED! Achievement Set");
              }
            }
          }

          // versusAI games won
          quantityArray = this.gamesrulesModel.getQuantityArrayForCollectibleId(this.gamesrulesModel.getCollectibleIdFromShortname("ai_game_won"));
          numTotalGamesWon = this.userdataModel.getNumTotalGamesWonInGamemodeCategory('versusAI');
          //console.log("+++++++ numTotalGamesWon versusAI: "+numTotalGamesWon);
          for (let i = 0; i < quantityArray.length; i++) {
            if (numTotalGamesWon >= quantityArray[i]) {
              if (this.userdataModel.setCollectibleGot(this.gamesrulesModel.getCollectibleIdFromShortname("ai_game_won"), quantityArray[i], this.gamesrulesModel.getIsglobalforanybookForCollectibleId(this.gamesrulesModel.getCollectibleIdFromShortname("ai_game_won")))) {
                trophiesMessagesArray.push("ai_game_won_achievement_" + quantityArray[i]);
                console.log(quantityArray[i] + " versus AI GAMES WON! Achievement Set");
              }
            }
          }

        }

        // Chunks completed
        if (chunkFinished) {
          quantityArray = this.gamesrulesModel.getQuantityArrayForCollectibleId(this.gamesrulesModel.getCollectibleIdFromShortname("chunks_completed"));
          var numTotalChunksCompletedInGamemodeCategoryALL = this.userdataModel.getNumTotalChunksCompletedInGamemodeCategory('all');
          for (let i = 0; i < quantityArray.length; i++) {

            if (numTotalChunksCompletedInGamemodeCategoryALL >= quantityArray[i]) {
              if (this.userdataModel.setCollectibleGot(this.gamesrulesModel.getCollectibleIdFromShortname("chunks_completed"), quantityArray[i], this.gamesrulesModel.getIsglobalforanybookForCollectibleId(this.gamesrulesModel.getCollectibleIdFromShortname("chunks_completed")))) {
                trophiesMessagesArray.push("chunks_completed_achievement_" + quantityArray[i]);
                console.log(quantityArray[i] + " CHUNKS COMPLETED!  Achievement Set");
              }
            }
          }
        }

        // Chunks completed in all gamemodes
        if (chunkFinished) {
          quantityArray = this.gamesrulesModel.getQuantityArrayForCollectibleId(this.gamesrulesModel.getCollectibleIdFromShortname("chunks_completed_all_gamemodes"));
          var numMaxChunksCompletedInGamemodeCategoryALL = this.userdataModel.getNumMaxChunksCompletedInGamemodeCategory('all');
          for (let i = 0; i < quantityArray.length; i++) {
            if (numMaxChunksCompletedInGamemodeCategoryALL >= quantityArray[i]) {
              if (this.userdataModel.setCollectibleGot(this.gamesrulesModel.getCollectibleIdFromShortname("chunks_completed_all_gamemodes"), quantityArray[i], this.gamesrulesModel.getIsglobalforanybookForCollectibleId(this.gamesrulesModel.getCollectibleIdFromShortname("chunks_completed_all_gamemodes")))) {
                trophiesMessagesArray.push("chunks_completed_all_gamemodes_achievement_" + quantityArray[i]);
                console.log(quantityArray[i] + " CHUNKS IN EACH GAMEMODE COMPLETED!  Achievement Set");
              }
            }
          }
        }

        // To avoid trophies message to overlap, fire one each 2 seconds
        var tmpI = 0;
        var that = this;
        if (trophiesMessagesArray.length > 0) {
          that.functions.showMessageTranslatedAchievement(that.toastCtrl, "msg_got_achievement", trophiesMessagesArray[tmpI]);
        }
        var subsequentToastIntervalId = setInterval(function () {
          tmpI++;
          if (tmpI < trophiesMessagesArray.length) {
            that.functions.showMessageTranslatedAchievement(that.toastCtrl, "msg_got_achievement", trophiesMessagesArray[tmpI]);
          } else {
            clearInterval(subsequentToastIntervalId);
          }
        }, this.functions.intervalBetweenToasts);

        //console.log("CollectiblesGOT AFT: "+JSON.stringify(this.userdataModel.getCollectiblesGot()));
        /* -------- END --- SETTING TROPHIES -------- */

        this.storeFinalGameData(typeOfwin).then((response) => {
          this.calculateFinalEntropyOfChunk(idChunkInBookAtGameEnd).then((response) => {
            // Entropy can be stored only after storing and calculate. This could be enhanced
            this.storeFinalEntropyGameData().then((response) => { });

            //Socket Call, send to other player game status saved to manage the disconnection after end game
            if(this.functions.isGameModeVersusPVPSync()){
              this.savedGameObj["savedgame"] = true;
              this.socket.emit('SavedGame', this.savedGameObj); //get data in SavedGame socket listner
            }
            
            if (this.functions.isGameModeVersus() || this.functions.isGameModeKids() || this.functions.isGameModeVersusPVPSync() || this.functions.isGameModeVersusPVPAsync()) {
              this.restoringSettingsAfterGameVersus();

              console.log("--------AFTER RESTORE--------" + "  Gamemode: " + this.functions.getGameMode() + "  Book: " + this.functions.getIdCurrentBook() + " BEF is versus: " + this.functions.getGameModeVersus() + "  BEF is versus PVP Async: " + this.functions.getGameModeVersusPVPAsync());

              this.functions.setGameModeVersus(false);
              this.functions.setGameModeVersusPVPAsync(false);

              console.log("  AFT is versus: " + this.functions.getGameModeVersus() + " AFT is versus PVP Async: " + this.functions.getGameModeVersusPVPAsync() + " AFT is versus PVP Sync: " + this.functions.getGameModeVersusPvPSync());
            }

            //Socket Call, send player data score to other player
            if (this.functions.isGameModeVersusPVPSync()) {
              typeOfwin = "versusPVPSync";
              this.socket.emit('sendDataScore', { //get data in getDataScore socket listner
                scorePartial: this.scorePartial,
                timeFinal: this.timeFinal,
                scoreFinalBonuses: this.scoreFinalBonuses,
                typeOfwin: typeOfwin,
                statusPVPAsync: this.functions.getStatusPVPAsync(),
                statusPVPSync: this.functions.getStatusPVPSync(),
                chunkFinished: chunkFinished,
                downEntropy: this.finalEntropyValues[0],
                upEntropy: this.finalEntropyValues[1],
                scoreFinalChallenger: this.scoreFinalChallenger,
                timeFinalChallenger: this.timeFinalChallenger,
                entropyFinalChallenger: this.entropyFinalChallenger,
                wasGameModeVersus: this.wasGameModeVersus,
                wasGameModeVersusPVPAsync: this.wasGameModeVersusPVPAsync,
                wasGameModeVersusPVPSync: this.wasGameModeVersusPVPSync,
                wasGameModeKids: this.wasGameModeKids,
                guidUser: this.userdataModel.getGuidUser(),
                username: this.userdataModel.getUsername(),
                idgame: this.playModel.getCurrentGameId()

              }); //send my data to other player

              //Set i'm not in game
              that.imIngame = false;

              /*
                console.log("that.otherPlayerInGame: "+that.otherPlayerInGame)
                console.log("that.userDisconnected: "+that.userDisconnected)
                console.log("that.otherPlayerInGame: "+that.otherPlayerInGame)
                console.log("that.otherPlayerSavedGame: "+that.otherPlayerSavedGame)
              */

              //If other player is not in game && not disconnected OR other player is not in game && other player just saved data
              //Store all players data and alert them
              if ((!that.otherPlayerInGame && !that.userDisconnected) || (!that.otherPlayerInGame && that.otherPlayerSavedGame)) { //If other player end game and is still connected save all data and show notification
                //console.log("Other player end game, alert ok")
                that.functions.showMessagePVP(that.toastCtrl, that.disconnectedMsg, "empty_string", that.otherPlayerUsername, 4000, "toastMessage toastMessageAchievement toastMessagePVP")
                /* console.log("OTHER Player scoreFinalChallenger: " + that.otherPlayerScore.scorePartial)
                 console.log("OTHER Player scoreFinalBonuses: " + that.otherPlayerScore.scoreFinalBonuses)
                 console.log("OTHER Player timeFinal: " + that.otherPlayerScore.timeFinal)
                 console.log("OTHER Player guid: " + that.otherPlayerScore.guidUser)
                 console.log("OTHER Player idgame: " + that.otherPlayerScore.idgame)*/
                var OtherPlayerTotalScore = that.otherPlayerScore.scorePartial + that.otherPlayerScore.scoreFinalBonuses
                /*  console.log("OTHER Player TotalScore: " + OtherPlayerTotalScore)
                  console.log("MY Player scoreFinalChallenger: " + this.scorePartial)
                  console.log("MY Player scoreFinalBonuses: " + this.scoreFinalBonuses)
                  console.log("MY Player timeFinal: " + this.timeFinal)
                  console.log("MY Player guid: " + this.userdataModel.getGuidUser())
                  console.log("MY Player idgame: " + this.playModel.getCurrentGameId())*/
                var myTotalScore = this.scorePartial + this.scoreFinalBonuses
                //  console.log("MY Player TotalScore: " + myTotalScore)
               

              //This set interval is necessary because the update process is too fast and the players data in db is not yet ready
              var waitUpdateDue = setInterval(function () {
                clearInterval(waitUpdateDue);
                  //Check who win and end game
                  if (OtherPlayerTotalScore >= myTotalScore || (OtherPlayerTotalScore > myTotalScore && that.otherPlayerScore.timeFinal <= this.timeFinal)) {
                    that.dataExchanger.setDataGameWinVersusPVPAsync(
                      that.otherPlayerScore.idgame,
                      that.otherPlayerScore.guidUser,
                      "win_versus").then((response) => {
                         console.log("OTHER Player WIN! so")
                         that.dataExchanger.setDataGameWinVersusPVPAsync(
                          that.playModel.getCurrentGameId(),
                          that.userdataModel.getGuidUser(),
                          "lost_versus").then((response) => {
                             console.log("MY Player LOST!")
                          });
                      });
                  } else {
                    that.dataExchanger.setDataGameWinVersusPVPAsync(
                      that.otherPlayerScore.idgame,
                      that.otherPlayerScore.guidUser,
                      "lost_versus").then((response) => {
                        console.log("OTHER Player Lost! so")

                        that.dataExchanger.setDataGameWinVersusPVPAsync(
                          that.playModel.getCurrentGameId(),
                          that.userdataModel.getGuidUser(),
                          "win_versus").then((response) => {
                             console.log("MY Player WIN!")
                          });
                      });
                  }
                }
                , 2500);

                //Socket call, The game is ended emit status
                this.socket.emit('end game', true); //get data in "end game" socket listner
               
                //Socket call, remove socket room
                this.socket.emit('removeRoom', true); //Emit remove room

                this.myPvpendGame = true
              }
              else if (this.userDisconnected) { // Other player is disconnected

                //This set interval is necessary because the update process is too fast and the players data in db is not yet ready
                var waitUpdate = setInterval(function () {
                  clearInterval(waitUpdate);
                  that.dataExchanger.setDataGameWinVersusPVPAsync(
                    that.playModel.getCurrentGameId(),
                    that.userdataModel.getGuidUser(),
                    "win_versus_for_disconnection").then((response) => {
                      // console.log("MY Player WIN for disconnection!")
                      that.functions.showMessagePVP(that.toastCtrl, that.disconnectedMsg, "empty_string", that.otherPlayerUsername, 4000, "toastMessage toastMessageAchievement toastMessagePVP");
                    });
                }
                  , 2500);
              }
              else {
                console.log("@ Other player is in game and not disconnected, alert ko")

              }
            }
            //END SOCKET

            this.navCtrl.push(EndgamePage, {
              scorePartial: this.scorePartial,
              timeFinal: this.timeFinal,
              scoreFinalBonuses: this.scoreFinalBonuses,
              typeOfwin: typeOfwin,
              statusPVPAsync: this.functions.getStatusPVPAsync(),
              statusPVPSync: this.functions.getStatusPVPSync(),
              chunkFinished: chunkFinished,
              downEntropy: this.finalEntropyValues[0],
              upEntropy: this.finalEntropyValues[1],
              scoreFinalChallenger: this.scoreFinalChallenger,
              timeFinalChallenger: this.timeFinalChallenger,
              entropyFinalChallenger: this.entropyFinalChallenger,
              wasGameModeVersus: this.wasGameModeVersus,
              wasGameModeVersusPVPAsync: this.wasGameModeVersusPVPAsync,
              wasGameModeVersusPVPSync: this.wasGameModeVersusPVPSync,
              wasGameModeKids: this.wasGameModeKids
            });

            this.functions.setEmptyStatusVersusPVPAsync();

            console.log("--------END GAME--------" + "  TypeOfwin: " + typeOfwin + "  ScorePartial: " + this.scorePartial + " and ScoreFinalBonuses: " + this.scoreFinalBonuses + "  Gamemode: " + this.functions.getGameMode() + "  Book:" + this.functions.getIdCurrentBook() + "  IdChunkInBookAtGameEnd: " + idChunkInBookAtGameEnd + " Chunk start: " + this.gamesrulesModel.getChunkStart(this.functions.getIdCurrentBook(), idChunkInBookAtGameEnd) + " Chunk end: " + this.gamesrulesModel.getChunkEnd(this.functions.getIdCurrentBook(), idChunkInBookAtGameEnd) + "  BookmarkLetter: " + this.currentBookmarkLetter + " scoreFinalChallenger: " + this.scoreFinalChallenger + " timeFinal: " + this.timeFinal + " timeFinalChallenger: " + this.timeFinalChallenger + "  WasGameModeKids: " + this.wasGameModeKids +"  WasGameModeVersus: " + this.wasGameModeVersus + " wasGameModeVersusPVPAsync: " + this.wasGameModeVersusPVPAsync + " is versus: " + this.functions.getGameModeVersus() + " is versus PVPAsync: " + this.functions.getGameModeVersusPVPAsync() + "  chunkFinished: " + chunkFinished + "  ----------------");

            clearInterval(this.refreshIntervalId);
            clearInterval(this.refreshVersusIntervalId);
            this.functions.stopBgMusic(this.randomGameBg);
            this.showablecurrentGuessableString = "";
            this.pauseInteractionWithKeyboard = false;
            this.functions.setGameModeVersusPVPSync(false);

            /*
            this.imIngame = true; 
            this.otherPlayerInGame = true; 
            this.myPvpendGame = false;
            this.otherPvpendGame = false;
            this.userDisconnected = false;*/
          });
        });
      }, 1500);
    }
  }

  giveUp() {
    console.log('giveup')
    this.pauseInteractionWithKeyboard = true;
    this.timeFinal = this.time;
    var idGame = this.playModel.getCurrentGameId();
    this.playModel.setGiveUp(idGame, true);

    //Check is a pvp game, in this case set typeOfwin in "pvp_pending"
    if (this.functions.isGameModeVersusPVPSync()) {
      this.endgame("pvp_pending");
    }
    else if (this.functions.isGameModeVersus() || (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameAcceptedVersusPVPAsync())) {
      this.endgame("lost_versus");
    } else {
      this.endgame("end_classic");
      //this.time=1;
    }
  }

  /* This move the bookmark numCharacterPriorOrPosterior character back (reverse mode) or forth (normal mode)
  to have a full prior or posterior text at end (reverse mode) or begin (normal mode) of the current book
  Long story short, this gift the first character of a book.
  */
  checkBootstrapBookmark() {
    var tmp;
    if (this.functions.isGameModeShannon() && !this.functions.isGameModeShannonReverse()) {
      tmp = this.functions.numCharacterPriorOrPosterior;
      if (this.bookmarkLetterAtGameBegin < tmp) {
        this.userdataModel.setBookmarkLetter(tmp);
        this.bookmarkLetterAtGameBegin = tmp;
      }
    }
    if (this.functions.isGameModeShannon() && this.functions.isGameModeShannonReverse()) {
      tmp = this.userdataModel.getIndexLastCharacterInBook() - this.functions.numCharacterPriorOrPosterior;
      if (this.bookmarkLetterAtGameBegin > tmp) {
        this.userdataModel.setBookmarkLetter(tmp);
        this.bookmarkLetterAtGameBegin = tmp;
      }
    }
  }

  fitBookmarkInsideChunk() {
    //this.currentChunkStart=this.gamesrulesModel.getChunkStart(this.functions.getIdCurrentBook(),this.currentChunk);
    //this.currentChunkEnd=this.gamesrulesModel.getChunkEnd(this.functions.getIdCurrentBook(),this.currentChunk);

    //console.log("BEF fitBookmark bookmarkLetterAtGameBegin"+this.bookmarkLetterAtGameBegin+" currentBookmarkLetter"+this.currentBookmarkLetter);
    if (this.bookmarkLetterAtGameBegin < this.currentChunkStart) {
      this.userdataModel.setBookmarkLetter(this.currentChunkStart);
      this.bookmarkLetterAtGameBegin = this.currentChunkStart;
      this.currentBookmarkLetter = this.currentChunkStart;
    }

    if (this.bookmarkLetterAtGameBegin > this.currentChunkEnd) {
      this.userdataModel.setBookmarkLetter(this.currentChunkEnd);
      this.bookmarkLetterAtGameBegin = this.currentChunkEnd;
      this.currentBookmarkLetter = this.currentChunkStart;
    }
    //console.log("AFT fitBookmark bookmarkLetterAtGameBegin"+this.bookmarkLetterAtGameBegin+" currentBookmarkLetter"+this.currentBookmarkLetter);
  }

  begingame() {

    if (this.functions.isGameModeKids()) {
      this.changeSettingsBeforeGameVersus();
    }

    if (this.userdataModel.isBookComplete(this.functions.getIdCurrentBook()) && this.functions.isGameModeKids()) {
      console.log("+++++ STARTING KIDS BOOK FROM BEGINNING");
      this.userdataModel.setBookmarkLetter(0);
      this.userdataModel.setCurrentIdChunkInBook(0); 
      this.userdataModel.setTimesWasPlayed(this.userdataModel.getTimesWasPlayed()+1);
    }else{
      //console.log("+++++ CONTINUE KIDS BOOK....");
    }

    this.currentGuessableString = "";
    this.textblocks = [];
    this.lettersGuessedOrNotHangman = [];
    this.maxAttemptsWrong = [];
    this.maxAttemptsTotal = [];
    this.finalEntropyValues = [-1, -1];
    this.pauseInteractionWithKeyboard = false;
    this.isGameEndedBoolean = false;
    this.currentKeyboard = 0;
    this.tutorialIsRunning = false;
    //this.setShiftStatus(false);
    this.resetLetterTried();
    this.functions.getGameMode();
    this.functions.getLanguage();
    this.fartherIndexDashReachedDuringGame = -1;
    this.wasGameModeVersus = false;
    this.wasGameModeVersusPVPAsync = false;
    this.wasGameModeKids = false;
    this.initialBonusGave = false;

    this.round = 0;
    this.attempt = 1;
    this.scorePartial = 0;
    this.scoreFinalChallenger = 0;
    this.timeFinalChallenger = 0;

    this.currentThermometerProgress = 100;

    this.bookmarkLetterAtGameBegin = this.userdataModel.getBookmarkLetter();

    this.chunkCharSkippedAtBeginningOrEndOfBook = 0;
    this.numChunksInBook = this.gamesrulesModel.getNumChunksOfBook(this.functions.getIdCurrentBook());

    // in versus the first 4 games simply are not chosen to avoid this problem
    if (!this.functions.isGameModeVersus() && !this.functions.isGameModeVersusPVPAsync() && !this.functions.isGameModeVersusPVPSync()) {
      this.skipChunkIfNotEnoughTextToShowForPriorOrPosterior();
      // Update variable about chunk and If the bookmark is not inside chunk, normalize situation. 
      // This normally happens if chunks are not contiguos or when the chunk has been modified by skipChunkIfNotEnoughTextToShowForPriorOrPosterior
      this.updateChunkVarsForChunk(this.currentChunk);
      this.getSingleGameAIdataToCompare(this.functions.aiToUseInGame, this.functions.getIdCurrentBook(), this.currentChunkStart);
    }

    this.currentBookmarkLetter = this.userdataModel.getBookmarkLetter();

    this.instext = '';
    this.mood = 'happy';
    this.numSbagliate = 0;
    this.numCorrette = 0;
    this.currentColorCatVersus = "none";

    if (this.functions.isGameModeVersus() || this.functions.isGameModeVersusPVPAsync() || this.functions.isGameModeVersusPVPSync()) {
      this.time = 0;
      this.currentChunkScoreAtGameBegin = 0;
      this.numLettersGuessedInCurrentChunkAtGameBegin = 0;
    } else {
      this.time = this.userdataModel.getCurrentTime();
      this.currentChunkScoreAtGameBegin = this.userdataModel.getCurrentChunkScore();
      this.numLettersGuessedInCurrentChunkAtGameBegin = this.userdataModel.getCurrentNumLettersGuessedInCurrentChunk();
    }

    this.currentLevel = this.userdataModel.getLevel();
    this.currentLevelProgress = this.gamesrulesModel.getProgressInLevelFromScore(this.userdataModel.getScore());
    this.timeFinal = -1;

    this.initializeGameModeVersus().then((response) => {
      this.checkBootstrapBookmark(); // only for shannon mode   
      this.http.get('assets/data/book_' + this.functions.getIdCurrentBook() + '.txt').subscribe(data => {
        var languageBook;
        if (this.functions.isGameModeVersus() || this.functions.isGameModeKids() || this.functions.isGameModeVersusPVPAsync() || this.functions.isGameModeVersusPVPSync()) {
          this.changeSettingsBeforeGameVersus();
          /* this is not truly necessary but at this point some functions variable got lost, showing the former value,
           for some reason I don't know. Debug showed it does it inside http...subscribe */
        }

        if (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameAcceptedVersusPVPAsync()) {
          languageBook = this.functions.getLanguageBookSentVersusPVPAsync();
        } else if (this.functions.isGameModeVersusPVPSync()) {
          languageBook = this.functions.getLanguageBookVersusPVPSync();
        } else {
          languageBook = this.functions.language;
        }

        var isVersus;
        if (this.functions.isGameModeVersus()) { isVersus = "versusAI"; }
        if (this.functions.isGameModeVersusPVPAsync()) { isVersus = "versusPVPAsync"; }
        if (this.functions.isGameModeVersusPVPSync()) { isVersus = "versusPVPSync"; }
        if (!this.functions.isGameModeVersus() && !this.functions.isGameModeVersusPVPAsync() && !this.functions.isGameModeVersusPVPSync()) { isVersus = "false"; }

        let obj = data['_body'];
        this.updateIndexesAndBookmark(false);
        this.splitText(obj).then((response) => {
          this.updateIndexesAndBookmark(false);

          // this must be done here in order to have indexElementToGuess properly set
          if (this.functions.isGameModeShannon()) { this.updateArrayLetterTriedHangman(); }

          this.updateCurrentChunkProgress();

          this.updateThermometer(this.currentBookmarkLetter)

          console.log("--------GAME SETTINGS--------" + " Gamemode: " + this.functions.getGameMode() + "  Guid User: " + this.userdataModel.getGuidUser() + "  Book:" + this.functions.getIdCurrentBook() + "  Lang: " + this.functions.language + "  #Letter GuessSim: " + this.functions.numLetterGuessableSimul[this.functions.getGameMode()] + "  #Letter In Game: " + this.functions.numLetterToConsiderInASingleGame + "  #Prior/Posterior: " + this.functions.numCharacterPriorOrPosterior + "  (" + JSON.stringify(this.priorOrPosteriorIndexes) + ")" + "  Versus: " + this.functions.isGameModeVersus() + "  Vs User: " + this.guidUserVersus + "  Versus PVP Async: " + this.functions.isGameModeVersusPVPAsync() + "  Vs User: " + this.guidUserVersus + "  Game: " + this.idGameVersus + " ----------------");

          this.playModel.addGame(
            this.userdataModel.getGuidUser(),               //guidUser
            this.playModel.getNewGameId(),                  //idGame
            this.functions.getIdCurrentBook(),              //idBook
            this.functions.getCurrentDevice(),              //currentDevice
            this.functions.numLetterGuessableSimul[this.functions.getGameMode()], //numLetterGuessableSimul
            this.functions.numCharacterPriorOrPosterior,    //numCharacterPriorOrPosterior
            this.functions.coefficentGoAheadOnCutBook,      //coefficentGoAheadOnCutBook
            this.functions.numLetterToConsiderInASingleGame,//numLetterToConsiderInASingleGame
            JSON.stringify(this.functions.booksPlayable),   //booksPlayable
            JSON.stringify(this.functions.booksPlayableInVersus),           //booksPlayableInVersus
            JSON.stringify(this.getUniqueIDCurrentKeyboardsString()),        //keyboards
            this.functions.currentTimestamp(),              //tsBegingame
            -1,                                             //tsTndgame
            this.functions.getGameMode(),                   //gamemode
            languageBook,                                   //language
            this.userdataModel.getScore(),                  //scoreInitial
            -1,                                             //scoreFinal
            this.gamesrulesModel.getParVersion(),           //parVersion
            this.bookmarkLetterAtGameBegin,                 //bookmarkLetterInitial
            -1,                                             //bookmarkLetterFinal
            this.currentChunk,                              //idChunkInBookInitial
            -1,                                             //idChunkInBookFinal
            this.userdataModel.getLevel(),                  //levelInitial
            -1,                                             //levelFinal
            this.fartherIndexDashReachedDuringGame,         //fartherIndexDashReachedDuringGame
            this.numCorrette,                               //numCorrette
            this.numSbagliate,                              //numSbagliate
            JSON.stringify(this.getBookmarkFromIndexInSlicedArray(this.priorOrPosteriorIndexes[0]) + "," + this.getBookmarkFromIndexInSlicedArray(this.priorOrPosteriorIndexes[1])),   //priorOrPosteriorIndexes
            false,                                          //giveup
            false,                                          //typeOfwin
            isVersus,                                       //isVersus
            this.functions.getStatusPVPAsync() == "sent" ? this.functions.currentTimestamp().toString() : "",             //sent
            this.functions.getStatusPVPAsync() == "accepted" ? this.functions.currentTimestamp().toString() : "",         //accepted
            "",                                             //declined
            "",                                             //rewarded
            this.guidUserVersus,                            //guidUserVersus
            this.idGameVersus,                              //idGameVersus
            -1,                                             //timeFinal
            -1,                                             //down_entropy
            -1,                                             //up_entropy
            this.getTimesWasPlayedInthisGamemode(),         //timesWasPlayed
            []                                              //wordstyped
          );
          if ((!this.functions.isGameModeVersus() && !this.functions.isGameModeVersusPVPAsync() && !this.functions.isGameModeVersusPVPSync()) || (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameSentVersusPVPAsync())) {
            this.timer();
          } else {
            this.updateCurrentGuessableString();
          }
        });
      });
    });
  }

  initializeGameModeVersus() {
    return new Promise((resolve) => {
      if (this.functions.isGameModeVersus()) { this.wasGameModeVersus = true; }
      if (this.functions.isGameModeVersusPVPAsync()) { this.wasGameModeVersusPVPAsync = true; }
      if (this.functions.isGameModeVersusPVPSync()) { this.wasGameModeVersusPVPSync = true; }
      if (this.functions.isGameModeKids()) { this.wasGameModeKids = true; }

      if (this.functions.isGameModeVersus() || (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameSentVersusPVPAsync())) {
        this.functions.setIdBookChosenVersusPVPAsync(this.chooseBookVersusAIandAsync());
      }

      if (this.functions.isGameModeVersusPVPSync()) {
        console.log("THIS IS A GAME SYNC");
        // ------ Getting challenger game ------ //
        this.challengerCurrentAttempt = 1;
        this.currentScoreChallenger = 0;
        //this.currentColorCatVersus = "none";
        this.changeSettingsBeforeGameVersus();

        this.bookmarkLetterAtGameBegin = this.gamesrulesModel.getChunkStart(this.functions.getIdBookChosenVersusPVPSync(), this.functions.getChunkChosenForVersusPVPSync());
        this.updateChunkVarsForChunk(this.gamesrulesModel.getChunkFromBookmarkLetter(this.functions.getIdCurrentBook(), this.bookmarkLetterAtGameBegin));

        this.guidUserVersus = this.initialGameDataForVersusSync.guidUser;
        this.idGameVersus = this.initialGameDataForVersusSync.idGame;
        this.scoreFinalChallenger = -1;
        this.timeFinalChallenger = -1;
        this.entropyFinalChallenger = -1;

        this.minBookmarkReachedChallenger = this.gamesrulesModel.getChunkStart(this.functions.getIdBookChosenVersusPVPSync(), this.functions.getChunkChosenForVersusPVPSync());
        this.maxBookmarkReachedChallenger = this.gamesrulesModel.getChunkEnd(this.functions.getIdBookChosenVersusPVPSync(), this.functions.getChunkChosenForVersusPVPSync());

        this.challengerGameDataVersus = [];
        /*   var myObj = {attempt: 1,
             bookmarkLetter: 0,
             isCorrect: false,
             score: 0,
             time: 0}
             this.challengerGameDataVersus.push(myObj)*/

        this.timerVersus();
        resolve("initializeGameModeVersusisOK");
      } else {
        if (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameSentVersusPVPAsync()) {
          console.log("THIS IS A GAME SENT");
          this.changeSettingsBeforeGameVersus();

          console.log("STARTING PLAY PVP ASYNC VERSUS (SENT): " + this.functions.getGuidChallengerPvpAsync());

          this.guidUserVersus = this.functions.getGuidChallengerPvpAsync();
          
          if (this.functions.isGameSentVersusPVPAsync()) {
            this.getChunkForPVPgame().then((response) => {
              this.functions.setTimesWasPlayedPVP(parseInt(response[0].timesWasPlayed));
              this.functions.setChunkChosenForVersusPVPAsync(parseInt(response[0].idChunkInBook)); //this.playModel.chooseRandomChunkForVersusPVPAsync(this.functions.getIdBookChosenVersusPVPAsync());
              this.bookmarkLetterAtGameBegin = this.gamesrulesModel.getChunkStart(this.functions.getIdBookChosenVersusPVPAsync(), this.functions.getChunkChosenForVersusPVPAsync());
              this.updateChunkVarsForChunk(this.gamesrulesModel.getChunkFromBookmarkLetter(this.functions.getIdCurrentBook(), this.bookmarkLetterAtGameBegin));

              resolve("initializeGameModeVersusisOK");
            });
          }
        } else {
          if (this.functions.isGameModeVersus() || (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameAcceptedVersusPVPAsync())) {
            console.log("THIS IS A GAME ACCEPTED OR VERSUS");

            // ------ Getting challenger game ------ //
            this.challengerCurrentAttempt = 1;
            this.currentScoreChallenger = 0;
            this.currentColorCatVersus = "none";

            this.getSingleGameDataVersus().then((response) => {
              if (this.initialGameDataForVersus.length <= 0) {
                console.log("ERROR: Game not found!");
              }
              /* This syncronize game to book and bookmark of the playback game. */

              this.dataExchanger.getTimesChunkWasPlayedPVP(this.userdataModel.getGuidUser(),this.initialGameDataForVersus[0].idChunkInBookInitial,this.initialGameDataForVersus[0].idBook).then((data) => {
                this.functions.timesWasPlayedPVP = parseInt(JSON.stringify(data));
                resolve('');
              });

              //console.log("XXXXXXX book: "+this.initialGameDataForVersus[0].idBook+" bookmarkLetterAtGameBegin: "+this.bookmarkLetterAtGameBegin+" book id: "+this.functions.getIdCurrentBook());
              //console.log("XXXXXXX this.initialGameDataForVersus[0]: "+JSON.stringify(this.initialGameDataForVersus[0]));

              // ------ Initializing gamemode ------ //
              this.changeSettingsBeforeGameVersus();

              //this.functions.timesWasPlayedPVP = this.playModel.getTimesGamePlayedPVPAsync(this.userdataModel.getGuidUser(),this.initialGameDataForVersus[0].idBook,this.initialGameDataForVersus[0].idChunkInBookInitial);
              
              this.guidUserVersus = this.initialGameDataForVersus[0].guidUser;
              this.idGameVersus = this.initialGameDataForVersus[0].idGame;
              this.scoreFinalChallenger = this.initialGameDataForVersus[0].scoreFinal - this.initialGameDataForVersus[0].scoreInitial;
              if (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameAcceptedVersusPVPAsync()) {
                this.timeFinalChallenger = this.initialGameDataForVersus[0].timeFinal;
              }
              this.entropyFinalChallenger = this.functions.roundTwoDecimal(this.initialGameDataForVersus[0].up_entropy);

              // ------ Initialize Array of challenger game ------//

              var tsInsertBefore;
              var tsBegingame;
              var intervalBefore;
              this.challengerGameDataVersus = [];
              //console.log("this.initialGameDataForVersus[0]: "+JSON.stringify(this.initialGameDataForVersus[0]));  
              //console.log("this.initialGameDataForVersus[0].wordstyped: "+JSON.stringify(this.initialGameDataForVersus[0].wordstyped));

              /* Here for player versus is 
                  tsBegingame=this.convertTimestamp(this.initialGameDataForVersus[0].tsBegingame); for the ts is a timestamp */
              tsBegingame = this.initialGameDataForVersus[0].tsBegingame;

              if (!this.functions.isGameModeVersusPVPAsync()) {
                tsInsertBefore = tsBegingame;
              } else {
                tsInsertBefore = this.convertTimestamp(tsBegingame);
              }

              intervalBefore = 0;
              this.minBookmarkReachedChallenger = Infinity;
              this.maxBookmarkReachedChallenger = -1;

              for (let j = 0; j < this.initialGameDataForVersus[0].wordstyped.length; j++) {
                //console.log("XXXXXXX interval: "+((this.initialGameDataForVersus[0].wordstyped[j].tsInsert)-tsInsertBefore));
                //console.log("XXXXXXX intervalBefore: "+intervalBefore);
                //console.log("XXXXXXX time: "+((this.initialGameDataForVersus[0].wordstyped[j].tsInsert)-tsInsertBefore+intervalBefore));
                //console.log("XXXXXXX bookmarkLetter:"+this.initialGameDataForVersus[0].wordstyped[j].bookmarkLetter);

                if (this.functions.isGameModeVersusPVPSync()) { //IF PVP SOCKET
                  console.log("PVP SYNC START IN");
                  this.challengerGameDataVersus.push({
                    time: this.convertTimestamp(this.initialGameDataForVersus[0].wordstyped[j].tsInsert) - tsInsertBefore + intervalBefore,
                    bookmarkLetter: this.initialGameDataForVersus[0].wordstyped[j].bookmarkLetter,
                    isCorrect: this.initialGameDataForVersus[0].wordstyped[j].isCorrect,
                    attempt: this.initialGameDataForVersus[0].wordstyped[j].attempt
                  });
                  intervalBefore += (this.convertTimestamp(this.initialGameDataForVersus[0].wordstyped[j].tsInsert) - tsInsertBefore);
                  tsInsertBefore = this.convertTimestamp(this.initialGameDataForVersus[0].wordstyped[j].tsInsert);

                }
                else {
                  if (!this.functions.isGameModeVersusPVPAsync()) {
                    this.challengerGameDataVersus.push({
                      time: this.initialGameDataForVersus[0].wordstyped[j].tsInsert - tsInsertBefore + intervalBefore,
                      bookmarkLetter: this.initialGameDataForVersus[0].wordstyped[j].bookmarkLetter,
                      isCorrect: this.initialGameDataForVersus[0].wordstyped[j].isCorrect,
                      attempt: this.initialGameDataForVersus[0].wordstyped[j].attempt
                    });
                    intervalBefore += (this.initialGameDataForVersus[0].wordstyped[j].tsInsert - tsInsertBefore);
                    tsInsertBefore = this.initialGameDataForVersus[0].wordstyped[j].tsInsert;
                  } else {
                    this.challengerGameDataVersus.push({
                      time: this.convertTimestamp(this.initialGameDataForVersus[0].wordstyped[j].tsInsert) - tsInsertBefore + intervalBefore,
                      bookmarkLetter: this.initialGameDataForVersus[0].wordstyped[j].bookmarkLetter,
                      isCorrect: this.initialGameDataForVersus[0].wordstyped[j].isCorrect,
                      attempt: this.initialGameDataForVersus[0].wordstyped[j].attempt
                    });
                    intervalBefore += (this.convertTimestamp(this.initialGameDataForVersus[0].wordstyped[j].tsInsert) - tsInsertBefore);
                    tsInsertBefore = this.convertTimestamp(this.initialGameDataForVersus[0].wordstyped[j].tsInsert);
                  }
                }
                /*  Here for player versus is 
                    time: this.convertTimestamp(this.initialGameDataForVersus[0].wordstyped[j].tsInsert)-tsInsertBefore+intervalBefore,
                    intervalBefore+=(this.convertTimestamp(this.initialGameDataForVersus[0].wordstyped[j].tsInsert)-tsInsertBefore);
                    tsInsertBefore=this.convertTimestamp(this.initialGameDataForVersus[0].wordstyped[j].tsInsert);
                for the ts is a timestamp */


                if (this.initialGameDataForVersus[0].wordstyped[j].bookmarkLetter < this.minBookmarkReachedChallenger) {
                  this.minBookmarkReachedChallenger = this.initialGameDataForVersus[0].wordstyped[j].bookmarkLetter;
                }
                if (this.initialGameDataForVersus[0].wordstyped[j].bookmarkLetter > this.maxBookmarkReachedChallenger) {
                  this.maxBookmarkReachedChallenger = this.initialGameDataForVersus[0].wordstyped[j].bookmarkLetter;
                }
              }
              if (this.initialGameDataForVersus[0].wordstyped.length == 0) {
                this.minBookmarkReachedChallenger = this.initialGameDataForVersus[0].bookmarkLetterInitial;
                this.maxBookmarkReachedChallenger = this.initialGameDataForVersus[0].bookmarkLetterInitial;
              }
              //console.log("XXXXXXX this.challengerGameDataVersus: "+JSON.stringify(this.challengerGameDataVersus));
              //console.log("XXXXXXX bookmark reached MIN: "+this.minBookmarkReachedChallenger+" MAX: "+this.maxBookmarkReachedChallenger);

              // In hangman mode game you can skip so the first bookmark of a game could not be the first of the game array
              // but the min bookmark reached in the challenger game
              this.bookmarkLetterAtGameBegin = this.minBookmarkReachedChallenger;
              this.updateChunkVarsForChunk(this.gamesrulesModel.getChunkFromBookmarkLetter(this.functions.getIdCurrentBook(), this.bookmarkLetterAtGameBegin));

              this.timerVersus();
              resolve("initializeGameModeVersusisOK");
            });

          } else {
            resolve("initializeGameModeVersusisOK");
          }
        }
      }
    });
  }

  updateScoreForChallengerGameDataVersus() {
    //attempt
    var attemptsWrongAItmp = 0;
    var scoreAItmp = 0;

    //console.log("XXXXXXX BEF challengerGameDataVersus:"+JSON.stringify(this.challengerGameDataVersus));
    for (let i = 0; i < this.challengerGameDataVersus.length; i++) {
      if (!this.challengerGameDataVersus[i].isCorrect) {
        this.challengerGameDataVersus[i].score = scoreAItmp;
        attemptsWrongAItmp++;
      } else {
        scoreAItmp = scoreAItmp + this.gamesrulesModel.calculateScore(
          attemptsWrongAItmp + 1,
          this.getParOfBookmark(this.challengerGameDataVersus[i].bookmarkLetter));
        this.challengerGameDataVersus[i].score = scoreAItmp;
        attemptsWrongAItmp = 0;
      }
    }
    //console.log("XXXXXXX AFT challengerGameDataVersus:"+JSON.stringify(this.challengerGameDataVersus));
  }

  changeRound() {
    this.round++;
    this.resetLetterTried();
    this.updateIndexesAndBookmark(false);

    this.updateCurrentGuessableString();

    if (this.isGameEnded()) {
      this.instext = '';
      this.endgame("end_classic");
    }
  }

  scrollOnFocusText() {
    if (document.getElementById("blinking_underscore_id")) { // otherwise this could be called before the screen was drawed (during ionViewWillEnter)
      var offsetBlinkingUnderscore = document.getElementById("blinking_underscore_id").offsetTop;
      this.scrollElement = this.showntextscroll.nativeElement;

      /*console.log("scroll");
      console.log("Height: "+this.scrollElement.scrollHeight);
      console.log("Top: "+this.showntextscroll.nativeElement.scrollTop);
      console.log("offsetBlinkingUnderscore: "+offsetBlinkingUnderscore);*/

      if (offsetBlinkingUnderscore <= 0) {
        this.scrollElement.scrollTop = 0;
      } else {
        if (this.functions.isVizMobile()) {
          this.scrollElement.scrollTop = offsetBlinkingUnderscore - 50;
        } else {
          this.scrollElement.scrollTop = offsetBlinkingUnderscore - 150;
        }
      }
    }
  }

  keyPressed(keyChosen, source) {
    /* keyChosen here could be:
    - phisical keyboard: (string) event.key i.e. textual descriptor of the button pressed (including things like Shift etc)
    - ingame keyboard: (number) index of the button on the current keyboard, 33 for spacebar, Shift, changekeyboard, Backspace, ArrowLeft, ArrowRight
    */

    //console.log("Key pressed: "+keyChosen+" from source: "+source);

    var indexKeyChosen;

    var isSpecialKey = false;
    if (keyChosen == 'Shift' || keyChosen == 'Backspace'
      || keyChosen == 'Enter' || keyChosen == 'changekeyboard'
      || keyChosen == 'ArrowLeft' || keyChosen == 'ArrowRight') {
      isSpecialKey = true;
    }

    if (source == 'ingamekeyboard' && !isSpecialKey) {
      indexKeyChosen = keyChosen;
      keyChosen = this.keyboards[this.functions.language][this.currentKeyboard][keyChosen];
    }

    // From here on, keyChosen is the letter pressed
    //console.log("Real Key pressed: "+keyChosen+" from source: "+source);

    /* Blocking key pressed on phisical keyboard if
    - they are not on game keyboard 
    - they are not special key
    - they are not uppercase letter (uppercase are accepted anyway not to disappoint pc user not able to use uppercase letters)
    */
    if (source == 'phisicalkeyboard') {
      if (
        !this.isAvailableOnIngameKeyboardKey(keyChosen)
        && !isSpecialKey
        && !this.functions.isLetterUppercase(keyChosen)
      ) {
        console.log("Key blocked! Reason - !in ingame keyboard: " + !this.isAvailableOnIngameKeyboardKey(keyChosen) + " - !special key: " + (!isSpecialKey) + " - !uppercase" + (!this.functions.isLetterUppercase(keyChosen)));
        return;
      }
      indexKeyChosen = this.getIndexInKeyboards(keyChosen, "currentKeyboard", "returnSingleIndex", "changeKeyboardWithIndexFound");
    }

    if (keyChosen == 'Shift') {
      // Shift is unesuful now due to the game become insensitive
      //this.shiftSwitch();
    }

    if (keyChosen == 'ArrowLeft' && this.functions.isGameModeShannonHangman() && !this.functions.isGameModeVersus() && !this.functions.isGameModeVersusPVPAsync() && !this.functions.isGameModeVersusPVPSync()) {
      this.moveCursor("left");
    }

    if (keyChosen == 'ArrowRight' && this.functions.isGameModeShannonHangman() && !this.functions.isGameModeVersus() && !this.functions.isGameModeVersusPVPAsync() && !this.functions.isGameModeVersusPVPSync()) {
      this.moveCursor("right");
    }

    if (keyChosen == 'Backspace') {
      this.instext = this.instext.substring(0, this.instext.length - 1);
    }

    if (keyChosen == 'Enter') {
      if (this.instext != "") {
        this.tryWord();
      }
    }

    if (keyChosen == 'changekeyboard') {
      this.changeKeyboard()
    }

    if (!isSpecialKey) {
      keyChosen = this.functions.normalizeForComparison(keyChosen);
      if (this.functions.isGameModeShannon() && !this.isLetterTried(indexKeyChosen)) {
        this.instext = keyChosen;
        // In Shannon mode any character you write is tried to guess
        this.tryWord();
      } else {
        if (this.isAvailableOnIngameKeyboardKey(keyChosen)) {
          this.instext += keyChosen;
        }
      }
    }
    if (!isSpecialKey) {
      this.animateButtonClicked("key_" + indexKeyChosen, 'colorgrey');
    } else {
      this.animateButtonClicked(keyChosen, 'colorgrey');
    }
  }

  animateButtonClicked(buttonId, classToAdd) {
    //console.log("animateButtonClicked buttonId:"+buttonId);
    if (document.getElementById(buttonId)) {
      document.getElementById(buttonId).classList.add(classToAdd);
      var clickAnimationIntervalId = setInterval(function () { document.getElementById(buttonId).classList.remove(classToAdd); clearInterval(clickAnimationIntervalId); clearInterval(this.clickAnimationIntervalId); }, 300);
      document.getElementById(buttonId).blur();
    } else {
      console.log("ERROR: Button Id not available for animation!");
    }
  }

  handleKeyboardEventsKeyDown(event: KeyboardEvent) {


    //console.log("Key Down: "+event.key);
    if (this.auth.startOverSystemActive) {
      this.auth.resetTimer();
    }
    if (this.navCtrl.getActive().name == "PlayPage" && !this.pauseInteractionWithKeyboard) {
      // this avoid enter and space to add extra character after a button is used and so focused
      event.preventDefault();
      event.stopPropagation();

      // In Shannon Mode this avoid you to try more than one time the same letter
      if (!this.functions.isGameModeShannon() ||
        (this.functions.isGameModeShannon() && !this.isLetterTried(this.getIndexInKeyboards(event.key, "allKeyboards", "returnSingleIndex", "changeKeyboardWithIndexFound")))) {
        this.keyPressed(event.key, 'phisicalkeyboard');
      }

      // Shift is currently disabled
      /*if(event.key=="Shift"){
        this.setShiftStatus(true);
      } */

      this.scrollOnFocusText();
    }
  }

  handleKeyboardEventsKeyUp(event: KeyboardEvent) {
    //console.log("Key up: "+event.key);
    if (this.auth.startOverSystemActive) {
      this.auth.resetTimer();
    }
    if (this.navCtrl.getActive().name == "PlayPage" && !this.pauseInteractionWithKeyboard) {
      // this avoid enter and space to add extra character after a button is used and so focused
      event.preventDefault();
      event.stopPropagation();
      this.scrollOnFocusText();

      // Shift is currently disabled
      /*
      if(event.key=="Shift"){
        this.setShiftStatus(false);
      } */
    }
  }

  keyIsDisabled(key) {
    // NOTE: THIS IS NOT used currently
    var keyIndexOnKeyboard = this.getIndexInKeyboards(key, "allKeyboards", "returnSingleIndex", "changeKeyboardWithIndexFound");
    if (keyIndexOnKeyboard > 0) {
      if ((<HTMLInputElement>document.getElementById("key_" + keyIndexOnKeyboard)).disabled) {
        return true;
      };
    }
    return false;
  }

  isAvailableOnIngameKeyboardKey(keyChosen) {
    if (this.getIndexInKeyboards(keyChosen, "allKeyboards", "returnSingleIndex", "changeKeyboardWithIndexFound") >= 0) {
      return true;
    } else {
      return false;
    }
  }

  /* NOTE: Shift is disabled so this is not used currently */
  /*setShiftStatus(status){
    if(this.functions.isGameModeShannon()){
      this.shiftOn=status;
      this.switchKeyboardForShift();
    }
  }

  shiftSwitch(){
    if(this.functions.isGameModeShannon()){
      if (this.shiftOn==true) {
        this.shiftOn=false;
      }else{
        this.shiftOn=true;
      }
      this.switchKeyboardForShift();
    }
  }

  switchKeyboardForShift(){
    if (this.shiftOn && this.currentKeyboard==1) {
      this.currentKeyboard=0;
    }
    if (!this.shiftOn && this.currentKeyboard==0) {
      this.currentKeyboard=1;
    }
  }*/
  /* ----------------------------------------------------- */

  changeKeyboard() {
    /*
    // NOTE: This is old code used for managing the Shift key
    if (this.currentKeyboard==0) {
      this.changeKeyboardToNum(2);
    }else{
      if ((this.currentKeyboard+1)>=this.numKeyboardsAvailable) {
        if(this.shiftOn){ this.changeKeyboardToNum(0); }
        if(!this.shiftOn){ this.changeKeyboardToNum(1); }
      }else{
        this.changeKeyboardToNum(this.currentKeyboard+1);;
      }
    }*/

    if ((this.currentKeyboard + 1) >= this.numKeyboardsAvailable) {
      this.changeKeyboardToNum(0);
    } else {
      this.changeKeyboardToNum(this.currentKeyboard + 1);;
    }
  }

  changeKeyboardToNum(numkeyboard) {
    /*if (numkeyboard<0 || numkeyboard>=this.numKeyboardsAvailable) {
      if(this.shiftOn){ this.currentKeyboard=0; }
      if(!this.shiftOn){ this.currentKeyboard=1; }
    }else{
      if (numkeyboard==0) { this.shiftOn=true; }
      if (numkeyboard==1) { this.shiftOn=false; }
      this.currentKeyboard=numkeyboard;
    }*/
    this.currentKeyboard = numkeyboard;
  }

  setKeyboardsSizes() {
    var count = 0;

    for (var k in this.keyboards[this.functions.language]) if (this.keyboards[this.functions.language].hasOwnProperty(k)) { ++count; };

    this.numKeyboardsAvailable = count;
    this.numLettersInSingleKeyboards = this.keyboards[this.functions.language][0].length;
  }

  getIndexInKeyboards(letter, allOrCurrentKeyboard, returnSingleOrAllIndexes, changeKeyboardWithIndexFound) {
    var indexesFound = [];
    var indexLetter = -1;
    var indexKeyboard = -1;

    //console.log("+++++ letter to search: "+JSON.stringify(letter));
    //console.log("+++++ keyboard: "+JSON.stringify(this.keyboards[this.functions.language]));
    //console.log("+++++ language: "+JSON.stringify(this.functions.language));

    // It could be found the same key in more than one keyboard
    for (var i = 0; i < this.numKeyboardsAvailable; i++) { // for each keyboard
      for (var j = 0; j < this.keyboards[this.functions.language][i].length; j++) { // for each element in keyboard
        if ((allOrCurrentKeyboard == "currentKeyboard" && i == this.currentKeyboard)
          || allOrCurrentKeyboard == "allKeyboards") {
          if (this.keyboards[this.functions.language][i][j] == letter) {
            indexesFound.push([i, j]);
          }
        }
      }
    }

    //console.log("+++++ indexes found: "+JSON.stringify(indexesFound));

    // if the key is in the current keyboard that is put in first position in array indexes found
    for (var x = 0; x < indexesFound.length; x++) {
      if (indexesFound[x][0] == this.currentKeyboard) {
        indexesFound = this.functions.array_move(indexesFound, x, 0)
        //console.log("+++++ indexes found AFT MOVE: "+JSON.stringify(indexesFound)); 
      }
    }

    // the first found is selected wheter is the unique or moved there for it is the one on the current keyboard
    if (indexesFound.length > 0) {
      indexKeyboard = indexesFound[0][0];
      indexLetter = indexesFound[0][1];
    }

    //console.log("indexLetter found: "+JSON.stringify(indexLetter));
    //console.log("indexKeyboard found: "+JSON.stringify(indexKeyboard));
    //console.log("this.currentKeyboard: "+JSON.stringify(this.currentKeyboard));

    if (indexKeyboard != this.currentKeyboard
      && indexKeyboard != -1
      && changeKeyboardWithIndexFound == "changeKeyboardWithIndexFound") {
      this.changeKeyboardToNum(indexKeyboard);
    }

    if (returnSingleOrAllIndexes == "returnAllIndexes") {
      return indexesFound;
    } else { // is "returnSingleIndex" and all error situations
      return indexLetter;
    }
  }

  /**
   * In slicedTextblock you'll typical have segments of multiple chunks: the current one completely
   * and part of the next or the previous just to have text to fill prior or posterior
   * This functions gets the index [i,j] where i it's the start index in slicedTextblock of the current chunk
   * and j is the end index of the current chunk
   */
  getBoundariesOfCurrentChunkInSlicedArray() {
    var currentChunkStartInSlicedArray = this.getIndexInSlicedArray(this.currentChunkStart);
    var currentChunkEndInSlicedArray = this.getIndexInSlicedArray(this.currentChunkEnd);
    return [currentChunkStartInSlicedArray, currentChunkEndInSlicedArray];
  }

  updateCurrentChunkProgress() {
    var numPriorOrPosteriorGifted = 0;
    if (this.currentChunk == 0 || this.currentChunk == (this.userdataModel.getNumchunktotalOfBook(this.functions.getIdCurrentBook()) - 1)) {
      numPriorOrPosteriorGifted = this.functions.numCharacterPriorOrPosterior;
    }

    if (this.chunkCharSkippedAtBeginningOrEndOfBook != 0) {
      numPriorOrPosteriorGifted = this.chunkCharSkippedAtBeginningOrEndOfBook;
      console.log("chunkCharSkippedAtBeginningOrEndOfBook: " + this.chunkCharSkippedAtBeginningOrEndOfBook);
    }

    if (numPriorOrPosteriorGifted > 0 && this.currentChunkScoreAtGameBegin == 0 && !this.initialBonusGave && !this.functions.isGameModeVersus() && !this.functions.isGameModeVersusPVPAsync()) {
      this.scorePartial = this.scorePartial + (this.functions.numCharacterPriorOrPosterior * 200);
      this.initialBonusGave = true;
    }

    this.currentChunkProgress = this.functions.calculatePercentage((this.numLettersGuessedInCurrentChunkAtGameBegin + numPriorOrPosteriorGifted + this.numCorrette), this.currentChunkTotalChar, "progress in chunk");
    //progress=Math.round(((this.numLettersGuessedInCurrentChunkAtGameBegin+numPriorOrPosteriorGifted+this.numCorrette)/this.currentChunkTotalChar)*100);
  }

  /* --------- END FUNCTIONS --------- */

  /* --------- FUNCTIONS GAME BOTH MODE --------- */

  updateIndexesAndBookmark(isLastRound) {
    this.updateIndexesAndBookmark_shannon(isLastRound);
  }

  isGameEnded() {
    // Round starts from 0, that's why +1
    if ((this.round) < this.numElementsToPlay) {
      return false;
    }
    if ((this.round) >= this.numElementsToPlay) {
      return true;
    }
  }

  getElementToGuess() {
    return this.textblocks[0].slicedTextblock.substring(this.indexElementToGuessInThisRound, this.indexElementToGuessInThisRound + 1);
  }

  startTutorial() {
    this.intro(); // tutorial intro.js. If put in 
  }

  calculateFinalEntropyOfChunk(idChunkInBookAtGameEnd) {
    return new Promise((resolve) => {
      this.getMaxAttemptsTotal(this.gamesrulesModel.getChunkStart(this.functions.getIdCurrentBook(), idChunkInBookAtGameEnd), this.gamesrulesModel.getChunkEnd(this.functions.getIdCurrentBook(), idChunkInBookAtGameEnd)).then((response) => {
        var attemptsTotalInChunk = []; // freed of zero values
        var j = 0;

        // remove zero values
        for (let i = 0; i < this.maxAttemptsTotal.length; i++) {
          if (this.maxAttemptsTotal[i] != 0) {
            attemptsTotalInChunk[j] = this.maxAttemptsTotal[i];
            j++;
          }
        }
        this.finalEntropyValues = [this.functions.roundTwoDecimal(this.functions.down_entro(attemptsTotalInChunk)), this.functions.roundTwoDecimal(this.functions.up_entro(attemptsTotalInChunk))];

        console.log("Up Entro: " + this.functions.up_entro(attemptsTotalInChunk) + "  Down Entro: " + this.functions.down_entro(attemptsTotalInChunk) + "  attemptsTotalInChunk: " + JSON.stringify(attemptsTotalInChunk));
        resolve("calculateFinalEntropyOfChunkIsOk");
      });
    });
  }

  // Generate array with attempt total (wrong+1 if correct)
  getMaxAttemptsTotal(startBookmark, endBookmark) {
    var maxAttemptsTotal = [];
    //console.log("+++++ this.maxAttemptsWrong: "+JSON.stringify(this.maxAttemptsWrong));

    return new Promise((resolve) => {

      this.dataExchanger.getMaxAttemptsWrongFromServer(startBookmark, endBookmark).then((maxAttemptsWrongJson) => {
        //console.log("+++++++ getMaxAttemptsWrongFromServer: "+JSON.stringify(maxAttemptsWrongJson));
        var i = 0;
        for (var attempt in maxAttemptsWrongJson) { // this is strange, any other way the compiler doesn't accept it
          maxAttemptsTotal[i] = maxAttemptsWrongJson[attempt].attemptsWrong;
          if (maxAttemptsWrongJson[attempt].isCorrect) {
            maxAttemptsTotal[i]++;
          }
          i++;
        }

        //console.log("+++++ maxAttemptsTotal: "+JSON.stringify(maxAttemptsTotal));
        this.maxAttemptsTotal = maxAttemptsTotal;
        resolve();
      });
    });
  }

  updateChunkVarsForChunk(idChunkInBook) {
    this.currentChunk = idChunkInBook;
    this.currentChunkStart = this.gamesrulesModel.getChunkStart(this.functions.getIdCurrentBook(), this.currentChunk);
    this.currentChunkEnd = this.gamesrulesModel.getChunkEnd(this.functions.getIdCurrentBook(), this.currentChunk);
    // Bookmark starts from 0 and that's why +1
    this.currentChunkTotalChar = (this.currentChunkEnd - this.currentChunkStart) + 1;

    this.fitBookmarkInsideChunk();
  }

  /* --------- FUNCTIONS GAME MODE SHANNON --------- */

  splitText(textblockToSplit) {
    return new Promise((resolve) => {

      this.indexElementToGuessInThisRound = 0;

      // The cut is made inside getArrayTextblocksForPlaying
      this.textblocks = this.functions.getArrayTextblocksForPlaying(textblockToSplit, this.bookmarkLetterAtGameBegin, this.functions.getIdCurrentBook(), this.gamesrulesModel.getChunkStart(this.functions.getIdCurrentBook(), this.currentChunk), this.gamesrulesModel.getChunkEnd(this.functions.getIdCurrentBook(), this.currentChunk));
      this.userdataModel.setIndexLastCharacterInBook(this.getWholeTextblockLength() - 1);
      // Get the text to show prior or posterior
      this.setTextToShow();
      // get data of par necessary to this game and update challenger game array with scores
      this.dataExchanger.getScoreParDataofTextblockFromServer(this.functions.getIdCurrentBook(), this.getBeginSlicedTexblock(), this.getEndSlicedTexblock()).then((response) => {
        this.parsOfTextblock = this.gamesrulesModel.getParsOfTextblock(this.functions.getIdCurrentBook(), this.getBeginSlicedTexblock(), this.getEndSlicedTexblock());
        //console.log("this.parsOfTextblock: "+JSON.stringify(this.parsOfTextblock));
        if (this.functions.isGameModeVersus() || this.functions.isGameModeVersusPVPSync() || (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameAcceptedVersusPVPAsync())) {
          this.updateScoreForChallengerGameDataVersus();
        }
        //console.log("this.parsOfTextblock: "+JSON.stringify(this.parsOfTextblock));
        this.resetLetterTriedHangman();
        this.initializemaxAttemptsWrongArray(this.getBeginSlicedTexblock(), this.getEndSlicedTexblock()).then((response) => {
          if (this.functions.isGameModeVersus() || this.functions.isGameModeVersusPVPSync() || (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameAcceptedVersusPVPAsync())) {
            this.initializeLettersGuessedOrNotHangmanVersusChallenger();
          }
          this.initializeArraysHangman();

          //if(this.functions.isGameModeShannonHangman()){
          this.numElementsToPlay = this.getNextGuessableLettersIndexesAccordingCurrentModeInLettersGuessedOrNotHangman(this.getIndexInSlicedArray(this.bookmarkLetterAtGameBegin), "all").length;
          //}
          if (this.functions.isGameModeShannon() && !this.functions.isGameModeShannonHangman()) {
            // count all characters in available textblocks
            // Removes from the count the characters of the sentence to be played that have been already guessed
            if (!this.functions.isGameModeShannonReverse()) {
              this.numElementsToPlay = this.textblocks[0].slicedTextblock.length - (this.getIndexInSlicedArray(this.bookmarkLetterAtGameBegin));
            } else {
              this.numElementsToPlay = (this.getIndexInSlicedArray(this.bookmarkLetterAtGameBegin)) + 1;
            }
          }

          resolve("splitTextIsOk");;
        });
      });
    });
  }

  updateIndexesAndBookmark_shannon(isLastRound) {
    console.log("--------UPDATE INDEXES--------" + "  Book:" + this.functions.getIdCurrentBook() + " Gamemode: " + this.functions.getGameMode() + " Chunk(InBook): " + this.currentChunk + " Start: " + this.currentChunkStart + " End:" + this.currentChunkEnd + " Tot Char:" + this.currentChunkTotalChar + "  ROUND:" + this.round + " and numElementsToPlay:" + this.numElementsToPlay + "  BEF indexElementToGuessInThisRound: " + this.indexElementToGuessInThisRound + "  BEF bookmarkLetterAtGameBegin:" + this.bookmarkLetterAtGameBegin + "  BEF currentBookmarkLetter:" + this.currentBookmarkLetter);

    /*if(this.round!=0 && !isLastRound && !this.functions.isGameModeShannonHangman()){
      //+1 (or -1) for the round increasing
      this.indexElementToGuessInThisRound=this.goNextDependingOnCurrentMode(this.indexElementToGuessInThisRound);
      this.currentBookmarkLetter=this.indexElementToGuessInThisRound+this.getBeginSlicedTexblock();
    }*/

    if (this.round != 0 && !isLastRound /*&& this.functions.isGameModeShannonHangman()*/) {
      if (!this.functions.isGameModeShannonReverse()) {
        this.indexElementToGuessInThisRound = this.getIndexNextLetterWithCursor("right");
      } else {
        this.indexElementToGuessInThisRound = this.getIndexNextLetterWithCursor("left");
      }
      this.currentBookmarkLetter = this.indexElementToGuessInThisRound + this.getBeginSlicedTexblock();
    }

    if (isLastRound) {
      //if (this.functions.isGameModeShannonHangman()){
      // indexFirstGuessableLetter return the first guessable according to mode, so it is ok even for reverse
      if (this.indexFirstGuessableLetter() != -1) {
        this.currentBookmarkLetter = this.indexFirstGuessableLetter() + this.getBeginSlicedTexblock();
      } else {
        // If it does not find the index available it must go beyond if possible or end the book
        if (!this.functions.isGameModeShannonReverse()) {
          // if the used textblock is end of book goes past the end ending the game and the book
          this.currentBookmarkLetter = this.getEndSlicedTexblock() + 1;
        } else {
          // if the used textblock is begin of book goes -1 ending the game and the book
          this.currentBookmarkLetter = this.getBeginSlicedTexblock() - 1;
        }
      }
      //}
    }

    if (this.round == 0 && !isLastRound) {
      this.currentBookmarkLetter = this.bookmarkLetterAtGameBegin;
      if (this.textblocks.length > 0) {
        this.indexElementToGuessInThisRound = this.getIndexInSlicedArray(this.currentBookmarkLetter);
      } else {
        this.indexElementToGuessInThisRound = 0;
      }
    }

    console.log("AFT indexElementToGuessInThisRound: " + this.indexElementToGuessInThisRound + "  AFT currentBookmarkLetter:" + this.currentBookmarkLetter + "  ----------------");
  }

  goNextDependingOnCurrentMode(element) {
    if (!this.functions.isGameModeShannonReverse()) {
      return element + 1;
    }
    if (this.functions.isGameModeShannonReverse()) {
      return element - 1;
    }
  }

  /* Here the prior (or posterior) text is calculated */
  setTextToShow() {
    var tmptextToShowPriorOrPosterior = "";
    var numCharAvailable = 0;
    var slicedTextblock = this.getSlicedTextblockToGuess();
    var beginTaking;
    var endTaking;
    var tmpIndexSpace;
    //console.log("getSlicedTextblockToGuess(): "+slicedTextblock);
    //console.log("this.currentBookmarkLetter: "+this.currentBookmarkLetter);

    if (!this.functions.isGameModeShannonReverse()) {
      numCharAvailable = this.getIndexInSlicedArray(this.currentBookmarkLetter); // not +1 for we must not consider the element on current bookmark
      if (numCharAvailable >= this.functions.numCharacterPriorOrPosterior) {

        beginTaking = this.getIndexInSlicedArray(this.currentBookmarkLetter) - this.functions.numCharacterPriorOrPosterior;
        endTaking = this.getIndexInSlicedArray(this.bookmarkLetterAtGameBegin);

        // This avoid to show incomplete words including char until the next space
        tmpIndexSpace = slicedTextblock.lastIndexOf(" ", beginTaking); //this search backwards
        if (tmpIndexSpace != -1 && tmpIndexSpace != beginTaking) {
          beginTaking = tmpIndexSpace;
        }
        if (tmpIndexSpace == -1) {
          beginTaking = 0;
        }

        this.priorOrPosteriorIndexes = [beginTaking, endTaking - 1]; // -1 for endTaking is not included in substring
        tmptextToShowPriorOrPosterior = slicedTextblock.substring(beginTaking, endTaking);
      } else {
        beginTaking = 0;
        endTaking = this.getIndexInSlicedArray(this.currentBookmarkLetter);
        this.priorOrPosteriorIndexes = [beginTaking, endTaking];
        tmptextToShowPriorOrPosterior = slicedTextblock.substring(beginTaking, endTaking);
      }
    } else {
      numCharAvailable = slicedTextblock.length - 1 - this.getIndexInSlicedArray(this.currentBookmarkLetter);
      if (numCharAvailable >= this.functions.numCharacterPriorOrPosterior) {
        beginTaking = this.getIndexInSlicedArray(this.currentBookmarkLetter) + 1;
        endTaking = this.getIndexInSlicedArray(this.currentBookmarkLetter) + this.functions.numCharacterPriorOrPosterior;

        // This avoid to show incomplete words including char until the next space
        tmpIndexSpace = slicedTextblock.indexOf(" ", endTaking);
        if (tmpIndexSpace != -1 && tmpIndexSpace != endTaking) {
          endTaking = tmpIndexSpace;
        }
        if (tmpIndexSpace == -1) {
          endTaking = this.getIndexInSlicedArray(this.getEndSlicedTexblock());
        }

        this.priorOrPosteriorIndexes = [beginTaking, endTaking - 1]; // -1 for endTaking is not included in substring
        tmptextToShowPriorOrPosterior = slicedTextblock.substring(beginTaking, endTaking);
      } else {
        beginTaking = this.getIndexInSlicedArray(this.currentBookmarkLetter) + 1;
        endTaking = slicedTextblock.length - 1;
        this.priorOrPosteriorIndexes = [beginTaking, endTaking];
        tmptextToShowPriorOrPosterior = slicedTextblock.substring(beginTaking);
      }
    }

    if (!this.functions.isGameModeShannonReverse() && beginTaking > 0) {
      tmptextToShowPriorOrPosterior = "..." + tmptextToShowPriorOrPosterior;
    }
    if (!this.functions.isGameModeShannonReverse()) {
      tmptextToShowPriorOrPosterior = tmptextToShowPriorOrPosterior + "...";
    }
    if (this.functions.isGameModeShannonReverse() && endTaking < this.userdataModel.getIndexLastCharacterInBook()) {
      tmptextToShowPriorOrPosterior = tmptextToShowPriorOrPosterior + "...";
    }
    if (this.functions.isGameModeShannonReverse()) {
      tmptextToShowPriorOrPosterior = "..." + tmptextToShowPriorOrPosterior;
    }

    tmptextToShowPriorOrPosterior = "<div class='priorOrPosteriorDiv'>" + tmptextToShowPriorOrPosterior + "</div>";

    this.textToShowPriorOrPosterior = tmptextToShowPriorOrPosterior;
    //console.log("this.textToShowPriorOrPosterior: "+this.textToShowPriorOrPosterior);   
  }

  isLetterTried(index) {
    var letterTried = false;
    if (index >= 0 && index < this.numLettersInSingleKeyboards) {
      letterTried = (this.letterTriedInThisRound[this.currentKeyboard][index] == true);
    }
    return letterTried;
  }

  setLetterTried(indexesArray, indexLetter) {
    if (indexLetter < 0) {
      indexLetter = this.indexElementToGuessInThisRound;
    }
    for (let i = 0; i < indexesArray.length; i++) {
      //console.log("set to true element: ["+indexesArray[i][0]+","+indexesArray[i][1]+"]");
      this.letterTriedInThisRound[indexesArray[i][0]][indexesArray[i][1]] = true;
    }

    //if (this.functions.isGameModeShannonHangman()) {
    // for example space bar is any keyboard, quotes and diacritics  are in two keyboard (uppercase and lowercase letters)
    for (let i = 0; i < indexesArray.length; i++) {
      //console.log("pushed in listOfLetterTriedInThisRound: ["+indexesArray[i][0]+","+indexesArray[i][1]+"]");
      this.listOfLetterTriedInThisRound[indexLetter].push(indexesArray[i]);
    }
    //}
  }

  resetLetterTried() {
    for (let i = 0; i < this.numKeyboardsAvailable; i++) {
      for (let j = 0; j < this.numLettersInSingleKeyboards; j++) {
        this.letterTriedInThisRound[i][j] = false;
      }
    }
  }

  getSlicedTextblockToGuess() {
    return this.textblocks[0].slicedTextblock;
  }

  getWholeTextblockLength() {
    return this.textblocks[0].wholeTextblockLength;
  }

  getBeginSlicedTexblock() {
    return this.textblocks[0].beginSlicedTexblock;
  }

  getEndSlicedTexblock() {
    return this.textblocks[0].endSlicedTexblock;
  }

  getIndexInSlicedArray(index) {
    return index - this.getBeginSlicedTexblock();
  }

  getBookmarkFromIndexInSlicedArray(index) {
    return index + this.getBeginSlicedTexblock();
  }

  initializemaxAttemptsWrongArray(startBookmark, endBookmark) {
    this.maxAttemptsWrong = [];
    var lenght = endBookmark - startBookmark + 1;

    return new Promise((resolve) => {
      for (let i = 0; i < lenght; i++) {
        if (!this.maxAttemptsWrong[i]) {
          this.maxAttemptsWrong[i] = 0;
        }
      }

      this.dataExchanger.getMaxAttemptsWrongFromServer(startBookmark, endBookmark).then((maxAttemptsWrongJson) => {
        //console.log("+++++++ getMaxAttemptsWrongFromServer: "+JSON.stringify(maxAttemptsWrongJson));
        var bookmarkInSlicedArray;
        for (var attempt in maxAttemptsWrongJson) { // this is strange, any other way the compiler doesn't accept it
          //console.log("++++++bletter: "+JSON.stringify(maxAttemptsWrongJson[attempt]));
          if (maxAttemptsWrongJson[attempt].bookmarkLetter > 0
            && maxAttemptsWrongJson[attempt].bookmarkLetter < endBookmark) {
            bookmarkInSlicedArray = this.getIndexInSlicedArray(maxAttemptsWrongJson[attempt].bookmarkLetter);
            this.maxAttemptsWrong[bookmarkInSlicedArray] = maxAttemptsWrongJson[attempt].attemptsWrong;
          }
          //console.log("+++ this.maxAttemptsWrong: "+JSON.stringify(this.maxAttemptsWrong));
        }
        resolve();
      });
    });
  }

  /* --------- FUNCTIONS GAME MODE HANGMAN --------- */

  /* This function initialize:
  - lettersGuessedOrNotHangman: if finds a letter guessed in previuos games it set the corresponding element in array to true
  - listOfLetterTriedInThisRound: if finds a letter guessed WRONG  in previuos games it set the corresponding element in array to set it tried
  */
  initializeArraysHangman() {
    var gamesdata = this.playModel.getWholeGamesData();
    this.lettersGuessedOrNotHangman = [];

    for (let i = 0; i < this.getSlicedTextblockToGuess().length; i++) {
      if (!this.lettersGuessedOrNotHangman[i]) {
        this.lettersGuessedOrNotHangman[i] = false;
      }
    }

    /*&& !this.functions.isGameModeKids()*/
    if (!this.functions.isGameModeVersus() && !this.functions.isGameModeVersusPVPAsync() && !this.functions.isGameModeVersusPVPSync()) { // in game versus it must not care about what guessed in previous games
      for (let i = 0; i < gamesdata.length; i++) { // for each game played      
        // if this game is on the current book and the same mode of the current 
        if (gamesdata[i].idBook == this.functions.getIdCurrentBook() &&
          gamesdata[i].gamemode == this.functions.getGameMode() &&
          gamesdata[i].timesWasPlayed == this.getTimesWasPlayedInthisGamemode()) {
          for (let j = 0; j < gamesdata[i].wordstyped.length; j++) { // for each attempt made in game played
            if (gamesdata[i].wordstyped[j].bookmarkLetter >= this.getBeginSlicedTexblock()
              && gamesdata[i].wordstyped[j].bookmarkLetter <= this.getEndSlicedTexblock()) {
              if (gamesdata[i].wordstyped[j].isCorrect) {
                this.lettersGuessedOrNotHangman[this.getIndexInSlicedArray(gamesdata[i].wordstyped[j].bookmarkLetter)] = true;
              } else {
                this.setLetterTried(this.getIndexInKeyboards(gamesdata[i].wordstyped[j].word, "allKeyboards", "returnAllIndexes", "doNOTchangeKeyboardWithIndexFound"), this.getIndexInSlicedArray(gamesdata[i].wordstyped[j].bookmarkLetter));
              }
            }
          }
        }
      }
    }

    if (!this.functions.isGameModeShannonReverse()) {
      this.fartherIndexDashReachedDuringGame = 0;
    } else {
      this.fartherIndexDashReachedDuringGame = this.lettersGuessedOrNotHangman.length - 1;
    }
    //console.log("FINAL this.lettersGuessedOrNotHangman: "+JSON.stringify(this.lettersGuessedOrNotHangman)); 
    this.updateCurrentGuessableString();
  }

  /* Here the string to be shown during game is calculated and updated while the timer flows and the player plays*/
  updateCurrentGuessableString() {
    var indexLastDashShowedOnScreen = this.indexLastGuessableLetter();
    var stainInt = 1;
    var bookmarkChallenger = -1;
    var scoreForCurrentLetter, parForCurrentLetter;

    if (this.challengerGameDataVersus && (this.functions.isGameModeVersus() || this.functions.isGameModeVersusPVPSync() || (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameAcceptedVersusPVPAsync()))) {
      // if (this.challengerCurrentAttempt <= this.challengerGameDataVersus.length) {

      //console.log("MAIN bookmarkChallengerBEFORE " + bookmarkChallenger)
      //console.log("MAIN challengerCurrentAttempt " + this.challengerCurrentAttempt)
      //console.log("MAIN this.challengerGameDataVersus.length " + this.challengerGameDataVersus.length)
      //console.log(this.challengerGameDataVersus)

      if (!this.functions.isObjectEmpty(this.challengerGameDataVersus)) {
        if (this.functions.isGameModeVersusPVPSync()) {
          bookmarkChallenger = this.challengerGameDataVersus[this.challengerCurrentAttempt - 2].bookmarkLetter;
          console.log("ARRAY BM: " + this.challengerGameDataVersus[this.challengerCurrentAttempt - 2].bookmarkLetter)
        } else {
          if (this.challengerCurrentAttempt <= this.challengerGameDataVersus.length) {
            bookmarkChallenger = this.challengerGameDataVersus[this.challengerCurrentAttempt - 1].bookmarkLetter;
          }
        }
      } else {
        bookmarkChallenger = -1;
      }
      console.log("MAIN bookmarkChallengerAFTER " + bookmarkChallenger);
    }

    if (!this.functions.isGameModeShannonReverse()) {
      this.fartherIndexDashReachedDuringGame = Math.max(this.fartherIndexDashReachedDuringGame, indexLastDashShowedOnScreen);
      indexLastDashShowedOnScreen = Math.max(this.fartherIndexDashReachedDuringGame, indexLastDashShowedOnScreen);
    } else {
      this.fartherIndexDashReachedDuringGame = Math.min(this.fartherIndexDashReachedDuringGame, indexLastDashShowedOnScreen);
      indexLastDashShowedOnScreen = Math.min(this.fartherIndexDashReachedDuringGame, indexLastDashShowedOnScreen);
    }
    this.currentGuessableString = "";

    for (let i = 0; i < this.lettersGuessedOrNotHangman.length; i++) {
      if (i >= this.getIndexInSlicedArray(this.bookmarkLetterAtGameBegin)
        && i <= indexLastDashShowedOnScreen
        && !this.functions.isGameModeShannonReverse()
        || i <= this.getIndexInSlicedArray(this.bookmarkLetterAtGameBegin)
        && i >= indexLastDashShowedOnScreen
        && this.functions.isGameModeShannonReverse()) {

        this.currentGuessableString += '<div class="letterBoxContainer';
        if (this.functions.isGameModeVersus() || this.functions.isGameModeVersusPVPSync() || (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameAcceptedVersusPVPAsync())) {
          if (i == this.getIndexInSlicedArray(bookmarkChallenger)) {
            this.currentGuessableString += ' challengerBookmark ';
          }
        }

        this.currentGuessableString += '">';

        if (this.functions.isGameModeVersus() || this.functions.isGameModeVersusPVPSync() || (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameAcceptedVersusPVPAsync())) {
          /* console.log("i: "+i)
           console.log("bookmarkChallenger: "+bookmarkChallenger)
           console.log("this.indexLastGuessableLetter(): "+this.indexLastGuessableLetter())
           console.log("this.getIndexInSlicedArray(bookmarkChallenger): "+this.getIndexInSlicedArray(bookmarkChallenger))*/

          if (i == this.getIndexInSlicedArray(bookmarkChallenger)
            || (bookmarkChallenger == -1 && i == this.indexLastGuessableLetter())) {
            if (this.currentColorCatVersus != "none") {
              if (!this.functions.isGameModeVersusPVPSync())
                this.currentGuessableString += '<div class="letterHidden robotcat catOn"><img class="robot_bottom" src="assets/img/rubedo_robot_white_' + this.currentColorCatVersus + '.png"><img class="robot_top" src="assets/img/rubedo_robot_white.png"></div>';
              else
                this.currentGuessableString += '<div class="letterHidden robotcat catOn"><img class="robot_bottom" src="assets/img/rubedo_human_white_' + this.currentColorCatVersus + '.png"><img class="robot_top" src="assets/img/rubedo_human_white.png"></div>';
              this.currentColorCatVersus = "none";
            } else {
              if (!this.functions.isGameModeVersusPVPSync())
                this.currentGuessableString += '<div class="letterHidden robotcat catOn"><img class="robot_bottom" src="assets/img/rubedo_robot_white.png"><img class="robot_top" src="assets/img/rubedo_robot_white.png"></div>';
              else
                this.currentGuessableString += '<div class="letterHidden robotcat catOn"><img class="robot_bottom" src="assets/img/rubedo_human_white.png"><img class="robot_top" src="assets/img/rubedo_human_white.png"></div>';
            }
          } else {
            if (!this.functions.isGameModeVersusPVPSync())
              this.currentGuessableString += '<div class="letterHidden robotcat catOff"><img src="assets/img/rubedo_robot_white.png"></div>';
            else
              this.currentGuessableString += '<div class="letterHidden robotcat catOff"><img src="assets/img/rubedo_human_white.png"></div>';

          }
        }

        if (this.lettersGuessedOrNotHangman[i] == true) {
          parForCurrentLetter = this.getParOfBookmark(i + this.getBeginSlicedTexblock());
          scoreForCurrentLetter = this.gamesrulesModel.calculateScoreForNextAttempt(this.maxAttemptsWrong[i], parForCurrentLetter);

          if (this.textblocks[0].slicedTextblock[i] == " ") {
            this.currentGuessableString += '<div class="letterClear">&#8239;</div>';
          } else {
            this.currentGuessableString += '<div class="letterClear">' + this.textblocks[0].slicedTextblock[i] + '</div>';
          }
          // For the next for maxAttemptsWrong contains only error and not the correct guess
          this.currentGuessableString += '<div class="numUnderDash numUnderDashGuessed';
          this.currentGuessableString += '">' + scoreForCurrentLetter + '</div>';
        } else {
          //parForCurrentLetter=this.getParOfBookmark(i+this.getBeginSlicedTexblock());
          //scoreForCurrentLetter=this.gamesrulesModel.calculateScoreForNextAttempt(this.maxAttemptsWrong[i],parForCurrentLetter);

          //console.log("i: "+i+" cbl: "+this.currentBookmarkLetter+" blb: "+this.bookmarkLetterAtGameBegin);
          if (i == this.getIndexInSlicedArray(this.currentBookmarkLetter)) {
            // If this is the letter currently highlighted and played
            this.currentGuessableString += '<div class="blinking_underscore';
            //if (this.maxAttemptsWrong[i]>parForCurrentLetter) {
            this.currentGuessableString += ' qm_' + this.currentBlinkingCursorColor + ' ';
            //}else{
            //this.currentGuessableString+=' qm_green ';
            //}
            this.currentGuessableString += '" id="blinking_underscore_id">__</div>';
          } else {
            // If this is NOT the letter currently highlighted and played
            if (stainInt >= 4) {
              stainInt = 1;
            } else {
              stainInt++;
            }
            // In games sent in versus async no stain should be showed
            if (!(this.functions.isGameModeVersusPVPAsync() && this.functions.isGameSentVersusPVPAsync())) {
              this.currentGuessableString += '<div class="letterHidden ';
              /*if (this.functions.isGameModeVersus()) {
                if (this.lettersGuessedOrNotHangmanVersusChallenger[i]==true) {
                  this.currentGuessableString+=' dashgreen ';
                }
              }*/
              this.currentGuessableString += ' ">' + '<img src="assets/img/stain' + stainInt;
              if (this.functions.isGameModeVersus() || this.functions.isGameModeVersusPVPSync() || (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameAcceptedVersusPVPAsync())) {
                if (this.lettersGuessedOrNotHangmanVersusChallenger[i]) {
                  if (this.lettersGuessedOrNotHangmanVersusChallenger[i] == true) {
                    this.currentGuessableString += '';
                  } else {
                    this.currentGuessableString += '_grsc';
                  }
                } else {
                  this.currentGuessableString += '_grsc';
                }
              } else {
                this.currentGuessableString += '_grsc';
              }
              this.currentGuessableString += '.png">'/*this.functions.symbolLetterHidden*/ + '</div>';
            }
          }
          // For visualization you show the score available if you go right for the 'next' attempt
          //this.currentGuessableString+='<div class="numUnderDash">'+this.gamesrulesModel.calculateScoreForNextAttempt(this.maxAttemptsWrong[i],this.getParOfBookmark(i+this.getBeginSlicedTexblock()))+'</div>'; 
          this.currentGuessableString += '<div class="numUnderDash invisibleOccSpace';
          //console.log("score: "+scoreForCurrentLetter+" par:"+parForCurrentLetter);
          this.currentGuessableString += '">' + scoreForCurrentLetter + '</div>';
        }

        //this.currentGuessableString+='<div class="numUnderDash">'+this.maxAttemptsWrong[i]+'</div>';  


        this.currentGuessableString += '</div>';
      }
    }

    this.currentGuessableString = "<div class='currentGuessableStringDiv'>" + this.currentGuessableString + "</div>";

    /* innerHTML strips away 'id' tag for security reasons. This way, id is retained */
    if (!this.functions.isGameModeShannonReverse()) {
      this.showablecurrentGuessableString = this.sanitizer.bypassSecurityTrustHtml(this.textToShowPriorOrPosterior + this.currentGuessableString);
    } else {
      this.showablecurrentGuessableString = this.sanitizer.bypassSecurityTrustHtml(this.currentGuessableString + this.textToShowPriorOrPosterior);
    }
    //console.log("this.currentGuessableString: !"+this.currentGuessableString+"!");
  }

  getParOfBookmark(bookmark) {
    //console.log("++++ bookmark: "+JSON.stringify(bookmark));
    // Find instead of filter just to save some computations (find the first element instead of looping them all)
    var bookmarkParData = this.parsOfTextblock.find(obj => obj.bookmarkInChunk == bookmark);
    // It could have been [this.getIndexInSlicedArray(bookmark)]; if they were synchronized, 
    // but no for there is the fucked last character with no par record in db
    //console.log("++++ bookmarkParData: "+JSON.stringify(bookmarkParData));
    return bookmarkParData.par;
  }

  moveCursor(direction) {
    var index = this.getIndexNextLetterWithCursor(direction);
    if (index >= 0) {
      this.currentBookmarkLetter = index + this.getBeginSlicedTexblock();
      this.indexElementToGuessInThisRound = index;
      this.updateArrayLetterTriedHangman();
      this.updateThermometer(this.currentBookmarkLetter);
    }
    //console.log("currBletter: "+this.currentBookmarkLetter+" index:"+this.indexElementToGuessInThisRound);
    this.updateCurrentGuessableString();
  }

  getIndexNextLetterWithCursor(direction) {
    var index;

    if (direction == "right") {
      index = this.getIndexNextLetterWithCursorRight();
      if (index == -1) { // If arrives at the end findind nothing, try in the other direction
        index = this.getIndexNextLetterWithCursorLeft();
        return index;
      } else {
        return index;
      }
    }

    if (direction == "left") {
      index = this.getIndexNextLetterWithCursorLeft();
      if (index == -1) { // If arrives at the end findind nothing, try in the other direction
        index = this.getIndexNextLetterWithCursorRight();
        return index;
      } else {
        return index;
      }
    }

    return -1;
  }

  // TODO use the indexes function for this
  getIndexNextLetterWithCursorRight() {
    //console.log("+++++++++++++++ getIndex RIGHT");
    //console.log("+++++++++++++++ this.currentBookmarkLetter: "+this.currentBookmarkLetter);
    var index;

    if (!this.functions.isGameModeShannonReverse()) { index = this.indexLastGuessableLetter(); }
    if (this.functions.isGameModeShannonReverse()) { index = this.indexFirstGuessableLetter(); }
    //console.log("+++++++++++++++ RIGHT index: "+index);

    if (this.getIndexInSlicedArray(this.currentBookmarkLetter) == index
      || index == -1) {
      return this.getIndexInSlicedArray(this.currentBookmarkLetter); // no going right of the ending 
    }

    for (let i = 0; i < this.lettersGuessedOrNotHangman.length; i++) {
      //console.log("i: "+i);
      if (i > this.getIndexInSlicedArray(this.currentBookmarkLetter)) {
        if (this.lettersGuessedOrNotHangman[i] == false) {
          //console.log("+++++++++++++++ index found: "+i);
          return i;
        }
      }
    }

    return -1;
  }

  getIndexNextLetterWithCursorLeft() {
    //console.log("+++++++++++++++ getIndex LEFT");
    //console.log("+++++++++++++++ this.currentBookmarkLetter: "+this.currentBookmarkLetter);

    var index;

    if (!this.functions.isGameModeShannonReverse()) { index = this.indexFirstGuessableLetter(); }
    if (this.functions.isGameModeShannonReverse()) { index = this.indexLastGuessableLetter(); }
    //console.log("+++++++++++++++ LEFT index: "+index);

    if (this.getIndexInSlicedArray(this.currentBookmarkLetter) == index
      || index == -1) {
      return this.getIndexInSlicedArray(this.currentBookmarkLetter); // no going right of the ending 
    }

    for (let i = this.lettersGuessedOrNotHangman.length; i >= 0; i--) {
      //console.log("i: "+i);
      if (i < this.getIndexInSlicedArray(this.currentBookmarkLetter)) {
        if (this.lettersGuessedOrNotHangman[i] == false) {
          //console.log("+++++++++++++++ index found: "+i);
          return i;
        }
      }
    }

    return -1;
  }

  getNextGuessableLettersIndexesAccordingCurrentModeInLettersGuessedOrNotHangman(index, numElementToTake) {
    var direction;
    if (!this.functions.isGameModeShannonReverse()) {
      direction = "right";
    } else {
      direction = "left";
    }
    return this.getNextGuessableLettersIndexesInLettersGuessedOrNotHangman(index, direction, numElementToTake);
  }


  // returns [] if doesn't find indexes or error are raised
  getNextGuessableLettersIndexesInLettersGuessedOrNotHangman(index, direction, numElementToTake) {
    var indexesFound = [];
    if (numElementToTake == "all") {
      numElementToTake = this.lettersGuessedOrNotHangman.length;
    }
    if (index < 0 || index >= this.lettersGuessedOrNotHangman.length) {
      console.log("ERROR: trying to find next guessable char with index out of boundaries!");
      return [];
    }

    if (direction == "right") {
      while (index < this.lettersGuessedOrNotHangman.length && numElementToTake > 0) {
        //console.log("****** index: "+index+" numElementToTake: "+numElementToTake);
        if (this.lettersGuessedOrNotHangman[index] == false) {
          indexesFound.push(index);
          numElementToTake--;
          index++;
          //console.log("****** index found: "+JSON.stringify(indexesFound)+" numElementToTake: "+numElementToTake);
        } else {
          index++;
          //console.log("****** retry!");
        }
      }
    }

    if (direction == "left") {
      while (index >= 0 && numElementToTake > 0) {
        //console.log("****** index: "+index+" numElementToTake: "+numElementToTake);
        if (this.lettersGuessedOrNotHangman[index] == false) {
          indexesFound.push(index);
          numElementToTake--;
          index--;
          //console.log("****** index found: "+JSON.stringify(indexesFound)+" numElementToTake: "+numElementToTake);
        } else {
          index--;
          //console.log("****** retry!");
        }
      }
    }

    //console.log("FINAL NextGuessableLettersIndexesInLettersGuessedOrNotHangman found: "+indexesFound);
    return indexesFound;
  }

  indexFirstGuessableLetter() {
    /* The first guessable is the first normally reading the guessable string from left to right
    In reverse is the first reading right to left */
    var indexesFound = this.getNextGuessableLettersIndexesAccordingCurrentModeInLettersGuessedOrNotHangman(this.getIndexInSlicedArray(this.bookmarkLetterAtGameBegin), 1);
    if (indexesFound.length > 0) {
      return indexesFound[0];
    } else {
      return -1;
    }
  }

  indexLastGuessableLetter() {
    /* The last guessable is the last normally reading the guessable string from left to right
    In reverse is the last reading right to left  */
    var indexesFound;
    var tmpNumLetterGuessableSimul = 0;

    if ((this.functions.isGameModeVersus() || this.functions.isGameModeVersusPVPSync() || (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameAcceptedVersusPVPAsync())) && this.maxBookmarkReachedChallenger) {
      tmpNumLetterGuessableSimul = Math.max(this.maxBookmarkReachedChallenger - this.minBookmarkReachedChallenger, this.functions.numLetterGuessableSimul[this.functions.getGameMode()]);
    } else {
      tmpNumLetterGuessableSimul = this.functions.numLetterGuessableSimul[this.functions.getGameMode()];
    }

    //console.log("++++++++++this.functions.numLetterGuessableSimul[this.functions.getGameMode()]: "+this.functions.numLetterGuessableSimul[this.functions.getGameMode()]);
    //console.log("++++++++++tmpNumLetterGuessableSimul: "+tmpNumLetterGuessableSimul);
    //console.log("++++++++++Math.max: "+Math.max(this.maxBookmarkReachedChallenger-this.minBookmarkReachedChallenger,this.functions.numLetterGuessableSimul[this.functions.getGameMode()]));

    indexesFound = this.getNextGuessableLettersIndexesAccordingCurrentModeInLettersGuessedOrNotHangman(this.getIndexInSlicedArray(this.bookmarkLetterAtGameBegin), tmpNumLetterGuessableSimul);

    //qui indice maggiore ra indexFound e ultimo challenger this.minBookmarkReachedChallenger
    if (indexesFound.length > 0) {
      /*if (this.functions.isGameModeVersus()) {
        console.log("indexesFound[indexesFound.length-1]: "+(indexesFound[indexesFound.length-1]));
          console.log("this.maxBookmarkReachedChallenger: "+this.maxBookmarkReachedChallenger);
          console.log("Math.max(indexesFound[indexesFound.length-1],this.maxBookmarkReachedChallenger): "+Math.max(indexesFound[indexesFound.length-1],this.maxBookmarkReachedChallenger));
        if (this.maxBookmarkReachedChallenger) {
          return Math.max(indexesFound[indexesFound.length-1],this.maxBookmarkReachedChallenger);
        }else{
          return indexesFound[indexesFound.length-1];
        }
      }else{
        return indexesFound[indexesFound.length-1];
      }*/

      return indexesFound[indexesFound.length - 1];

    } else {
      return -1;
    }
  }

  resetLetterTriedHangman() {
    this.listOfLetterTriedInThisRound = [];
    for (let i = 0; i < this.getSlicedTextblockToGuess().length; i++) {
      if (!this.listOfLetterTriedInThisRound[i]) {
        this.listOfLetterTriedInThisRound[i] = [];
      }
    }
  }

  updateArrayLetterTriedHangman() {
    this.resetLetterTried();
    for (let i = 0; i < this.listOfLetterTriedInThisRound[this.indexElementToGuessInThisRound].length; i++) {
      this.letterTriedInThisRound[this.listOfLetterTriedInThisRound[this.indexElementToGuessInThisRound][i][0]][this.listOfLetterTriedInThisRound[this.indexElementToGuessInThisRound][i][1]] = true;
    }
  }
  /* --------- END FUNCTIONS GAME MODE HANGMAN --------- */

  intro() {
    //this.introJsVar.start()


    //var device = this.functions.getCurrentDevice();
    var numTutorialSteps = 15;
    var skipLabel = "Skip";
    var doneLabel = "Done";
    var nextLabel = ">";
    var prevLabel = "<";
    var idMoodOnStep;

    if (this.functions.getLanguage() == "it") {
      skipLabel = "Salta";
      doneLabel = "Fatto";
    }
    var tutorialSteps = {
      tooltipClass: 'introTooltip',
      showStepNumbers: false,
      exitOnEsc: true,
      overlayOpacity: 1,
      showBullets: false,
      steps: [],
      hidePrev: true,
      hideNext: true,
      keyboardNavigation: false, // enabling this cause an error if going after the end of tutorial using arrow button on keyboard
      skipLabel: skipLabel,
      doneLabel: doneLabel,
      nextLabel: nextLabel,
      prevLabel: prevLabel
    };
    this.tutorialIsRunning = true;

    for (let i = 0; i <= numTutorialSteps - 1; i++) {
      this.translate.get("tutorial_step_" + i).subscribe(value => {
        this.tutorialMessages[i] = value;
      });
      this.translate.get("tutorial_step_" + i + "_id_element").subscribe(value => {
        this.tutorialIdElement[i] = value;
      });
      this.translate.get("tutorial_step_" + i + "_position").subscribe(value => {
        this.tutorialPosition[i] = value;
      });
    }

    // Skip step 5 of tutorial on mobile
    var isMobile = this.functions.isCurrentDevice('mobile');
    if (isMobile) {
      this.tutorialMessages.splice(5, 1);
      this.tutorialIdElement.splice(5, 1);
      this.tutorialPosition.splice(5, 1);
      numTutorialSteps--;
    }

    for (let i = 0; i <= numTutorialSteps - 1; i++) {
      tutorialSteps.steps.push({
        element: this.tutorialIdElement[i],
        intro: this.tutorialMessages[i],
        position: this.tutorialPosition[i]
      });
    }

    this.introJsVar.setOptions(tutorialSteps);

    // Here I use arrow function in order not to loose the context 'this'
    this.introJsVar.onbeforechange(() => {
      idMoodOnStep = this.introJsVar._currentStep;
      if (isMobile && idMoodOnStep >= 5) {
        idMoodOnStep++;
      }
      this.translate.get("tutorial_step_" + idMoodOnStep + "_mood").subscribe(value => {
        this.mood = value;
      });
    });

    this.introJsVar.oncomplete(() => {
      this.tutorialIsRunning = false;
    });

    this.introJsVar.onexit(() => {
      this.tutorialIsRunning = false;
    });

    //  this.introJsVar.start();
    this.introJsVar.start().goToStep(1);
  }

  /* --------- FUNCTIONS GAME MODE VERSUS --------- */

  getChunkForPVPgame() {
    return new Promise((resolve) => {
      this.dataExchanger.getChunkForPVPgame(this.userdataModel.getGuidUser(), this.functions.getGuidChallengerPvpAsync(), this.functions.getIdBookChosenVersusPVPAsync()).then((response) => {
        resolve(response);
      });
    });
  }

  getSingleGameDataVersus() {
    return new Promise((resolve) => {
      if (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameAcceptedVersusPVPAsync()) {
        this.initialGameDataForVersus = this.playModel.getGameSentDataPVPAsync(this.functions.getGuidChallengerPvpAsync(), this.functions.getIdGameSentVersusPVPAsync());
        //console.log("++++++ 1 this.initialGameDataForVersus: " + JSON.stringify(this.initialGameDataForVersus));
        resolve("getSingleGameDataVersusIsOk")
      }

      if (this.functions.isGameModeVersus()) {
        //guidUser,idGame,idBook,gamemode,language,challengerIsAI
        this.dataExchanger.getSingleGameForVersus(this.functions.aiToUseInGame, "", this.functions.getIdBookChosenVersusPVPAsync(), "", this.functions.language, true).then((initialGameDataForVersus) => {
          this.initialGameDataForVersus = initialGameDataForVersus;
          //console.log("++++++ 2 this.initialGameDataForVersus: " + JSON.stringify(this.initialGameDataForVersus));
          resolve("getSingleGameDataVersusIsOk");
        });
      }

      if (this.functions.isGameModeVersusPVPSync()) { //FOR SYNC PVP SOCKET
        //this.initialGameDataForVersus = this.initialGameDataForVersusTMP; //OBJ SET DATA
        //console.log("++++++ 3 this.initialGameDataForVersus: " + JSON.stringify(this.initialGameDataForVersus));
        resolve("getSingleGameDataVersusIsOk");
      }
    });
  }

  getSingleGameAIdataToCompare(guidUser, idBook, chunkStart) {
    return new Promise((resolve) => {
      this.dataExchanger.getSingleGameAIdataToCompareExchanger(guidUser, idBook, chunkStart).then((response) => {
        this.scoreFinalChallenger = parseInt(response['scoreFinal']) - parseInt(response['scoreInitial']);
        this.entropyFinalChallenger = this.functions.roundTwoDecimal(response['up_entropy']);
      });
    });
  }

  initializeLettersGuessedOrNotHangmanVersusChallenger() {
    this.lettersGuessedOrNotHangmanVersusChallenger = [];

    for (let i = 0; i < this.getSlicedTextblockToGuess().length; i++) {
      if (!this.lettersGuessedOrNotHangmanVersusChallenger[i]) {
        this.lettersGuessedOrNotHangmanVersusChallenger[i] = false;
      }
    }
  }

  timerVersus() {
    this.refreshIntervalId = setInterval(() => {
      if (!this.isGameEndedBoolean && !this.tutorialIsRunning) {
        this.time++;
      }
      // check if player is ahead challenger or the opposite and endgame with win or lost outcome
      // Player Wins challenge!
      console.log("score plr vs opp: " + this.attempt + " - " + this.challengerCurrentAttempt + "/" + (this.challengerGameDataVersus.length));

      /* -----------
      // This makes the player or challenger win if: challenger completes his game before player arrives where challenger arrived
      if(this.attempt>=(this.challengerGameDataVersus.length)){
        this.endgame("win_versus");
        return;
      }
      // Challenger Wins challenge!
      if (this.challengerCurrentAttempt>=this.challengerGameDataVersus.length) {
        this.endgame("lost_versus");
        return;
      }
      ----------- */
      if (this.challengerCurrentAttempt <= this.challengerGameDataVersus.length) { // If challenger has done his game, then stop
        console.log("----------------");
        console.log("this.challengerCurrentAttempt: " + this.challengerCurrentAttempt + " this.challengerGameDataVersus.length: " + this.challengerGameDataVersus.length);
        console.log("current time: " + this.time + " challenger time:" + this.challengerGameDataVersus[this.challengerCurrentAttempt - 1].time + " iscorrect: " + this.challengerGameDataVersus[this.challengerCurrentAttempt - 1].isCorrect)
        if (this.time >= this.challengerGameDataVersus[this.challengerCurrentAttempt - 1].time) {
          this.currentColorCatVersus = "red";
          // You could have more than one attempt in the same second X, so here it is the reason for this while
          while (this.time >= this.challengerGameDataVersus[this.challengerCurrentAttempt - 1].time) {
            if (this.challengerGameDataVersus[this.challengerCurrentAttempt - 1].isCorrect) {
              console.log("Challenger Avanza! Current attempt: " + this.challengerCurrentAttempt + " time:" + this.challengerGameDataVersus[this.challengerCurrentAttempt - 1].time + " bookmarkLetter: " + this.challengerGameDataVersus[this.challengerCurrentAttempt - 1].bookmarkLetter);
              this.lettersGuessedOrNotHangmanVersusChallenger[this.getIndexInSlicedArray(this.challengerGameDataVersus[this.challengerCurrentAttempt - 1].bookmarkLetter)] = true;
              this.currentColorCatVersus = "green";
            } else {
              console.log("Challenger NON Avanza! Current attempt: " + this.challengerCurrentAttempt + " time:" + this.challengerGameDataVersus[this.challengerCurrentAttempt - 1].time + " bookmarkLetter: " + this.challengerGameDataVersus[this.challengerCurrentAttempt - 1].bookmarkLetter);
            }
            if ((this.challengerCurrentAttempt + 1) < this.challengerGameDataVersus.length) {
              if (this.challengerGameDataVersus[this.challengerCurrentAttempt - 1].isCorrect) {
                this.currentScoreChallenger = this.challengerGameDataVersus[this.challengerCurrentAttempt - 1].score;
              }
              this.challengerCurrentAttempt++;
              console.log("AVANZO 1")
            } else if ((this.challengerCurrentAttempt + 1) >= this.challengerGameDataVersus.length) {

              if (this.challengerGameDataVersus[this.challengerCurrentAttempt - 1].isCorrect) {
                this.currentScoreChallenger = this.challengerGameDataVersus[this.challengerCurrentAttempt - 1].score;
              }
              this.challengerCurrentAttempt++;
              console.log("AVANZO 2")
              break;
            }
          }
          this.updateCurrentGuessableString();
        }
        console.log("----------------");
      } else {
        this.currentColorCatVersus = "none";
      }
    }, 1000);
  }

  convertTimestamp(timestampInMilliseconds) {
    return (timestampInMilliseconds - (timestampInMilliseconds % 1000)) / 1000;
  }

  changeSettingsBeforeGameVersus() {
    this.savedSettingsBeforeVersusGame[0] = this.functions.getGameMode();
    this.savedSettingsBeforeVersusGame[1] = this.functions.getIdCurrentBook();

    if (this.functions.isGameModeVersusPVPSync()) {
      this.savedSettingsBeforeVersusGame[2] = this.functions.getLanguage();
      this.functions.changeLanguageTo(this.functions.getLanguageBookVersusPVPSync());
    }

    // The game you've been challenged could be not in your language so we must change the language
    // to the one of the sent game, just for the time being
    if (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameAcceptedVersusPVPAsync()) {
      this.savedSettingsBeforeVersusGame[2] = this.functions.getLanguage();
      this.functions.changeLanguageTo(this.functions.getLanguageBookSentVersusPVPAsync());
    }

    console.log("--- Saving gamemode: " + this.savedSettingsBeforeVersusGame[0] + " book: " + this.savedSettingsBeforeVersusGame[1]);
    
    if(this.functions.isGameModeKids()){
      this.userdataModel.setSettingsCurrentGamemode("shannon");
      this.functions.setGamemodeTo("shannon");
    }else{
      this.userdataModel.setSettingsCurrentGamemode("shannon_hangman");
      this.functions.setGamemodeTo("shannon_hangman");
    }

    console.log("--- Saved gamemode: " + this.functions.getGameMode());

    if (this.functions.isGameModeVersusPVPSync()) {
      this.functions.setIdCurrentBook(this.functions.getIdBookChosenVersusPVPSync());
    }

    if (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameSentVersusPVPAsync()) {
      this.functions.setIdCurrentBook(this.functions.getIdBookChosenVersusPVPAsync());
    }

    if (this.functions.isGameModeVersus() || (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameAcceptedVersusPVPAsync())) {
      this.functions.setIdCurrentBook(this.initialGameDataForVersus[0].idBook);
    }
  }

  restoringSettingsAfterGameVersus() {
    this.userdataModel.setSettingsCurrentGamemode(this.savedSettingsBeforeVersusGame[0]);
    this.functions.setGamemodeTo(this.savedSettingsBeforeVersusGame[0]);
    if(this.functions.isGameModeKids()){
      this.functions.setIdCurrentBook(1);
    }else{
      this.functions.setIdCurrentBook(this.savedSettingsBeforeVersusGame[1]);
    }

    if (this.functions.isGameModeVersusPVPAsync() && this.functions.isGameAcceptedVersusPVPAsync()) {
      this.functions.changeLanguageTo(this.savedSettingsBeforeVersusGame[2]);
    }
    console.log("--- Restoring gamemode: " + this.savedSettingsBeforeVersusGame[0] + " book: " + this.savedSettingsBeforeVersusGame[1] + " language: " + this.savedSettingsBeforeVersusGame[2]);
  }

  chooseBookVersusAIandAsync() {
    var randomItem = 0;
    var bookPlayableInCurrentLanguage = [];
    var booksPlayableInCurrentMode = [];

    if (this.functions.isGameModeVersus()) {
      booksPlayableInCurrentMode = this.functions.booksPlayableInVersus;
    }

    if (this.functions.isGameModeVersusPVPAsync()) {
      booksPlayableInCurrentMode = this.functions.booksPlayableInVersusPVPAsync;
    }

    for (let i = 0; i < booksPlayableInCurrentMode.length; i++) {
      if (this.userdataModel.getLanguageofBook(booksPlayableInCurrentMode[i]) == this.functions.language) {
        bookPlayableInCurrentLanguage.push(booksPlayableInCurrentMode[i]);
      }
    }
    if (bookPlayableInCurrentLanguage.length == 0) {
      console.log("ERROR: book available for versus not found!");
      return 1;
    }
    randomItem = this.functions.getRandomIntBetween(0, bookPlayableInCurrentLanguage.length - 1);
    return bookPlayableInCurrentLanguage[randomItem];
  }

  getNextChunk(idChunkInBook) {
    if (this.functions.isGameModeShannonReverse()) {
      return idChunkInBook - 1;
    } else {
      return idChunkInBook + 1;
    }
  }

  getFirstChunkPlayableOfBook() {
    var chunkTmp;
    if (!this.functions.isGameModeShannonReverse()) {
      chunkTmp = 0;
    }
    if (this.functions.isGameModeShannonReverse()) {
      chunkTmp = this.userdataModel.getNumchunktotalOfBook(this.functions.getIdCurrentBook()) - 1;
    }
    var chunkCharSkipped = 0;
    var chunkLenght = 0;
    var numChunkSkipped = 0;
    var numChunksInBook = this.gamesrulesModel.getNumChunksOfBook(this.functions.getIdCurrentBook());

    chunkCharSkipped = this.gamesrulesModel.getChunkLength(this.functions.getIdCurrentBook(), chunkTmp);

    while (chunkCharSkipped <= this.functions.numCharacterPriorOrPosterior && chunkTmp >= 0 && chunkTmp <= numChunksInBook) {
      chunkTmp = this.getNextChunk(chunkTmp);
      numChunkSkipped++;
      chunkLenght = this.gamesrulesModel.getChunkLength(this.functions.getIdCurrentBook(), chunkTmp);
      if ((chunkCharSkipped + chunkLenght) > this.functions.numCharacterPriorOrPosterior) {
        this.chunkCharSkippedAtBeginningOrEndOfBook = this.functions.numCharacterPriorOrPosterior - chunkCharSkipped - numChunkSkipped;
      }
      chunkCharSkipped = chunkCharSkipped + chunkLenght;
    }
    return chunkTmp;
  }

  skipChunkIfNotEnoughTextToShowForPriorOrPosterior() {
    var chunkTmp = this.userdataModel.getCurrentIdChunkInBook();
    var chunkCharSkipped = 0;
    var chunkLenght = 0;
    var numChunkSkipped = 0;
    //console.log("+++++++ chunkTmp: "+chunkTmp);
    // If chunk is the first or the last and numCharacterPriorOrPosterior is longer than the chunk skip 
    // to the first possible, allowing a text to show long at least numCharacterPriorOrPosterior
    if (
      (!this.functions.isGameModeShannonReverse() && chunkTmp == 0)
      || (this.functions.isGameModeShannonReverse() && chunkTmp == (this.userdataModel.getNumchunktotalOfBook(this.functions.getIdCurrentBook()) - 1))
    ) {
      chunkCharSkipped = this.gamesrulesModel.getChunkLength(this.functions.getIdCurrentBook(), chunkTmp);
      //console.log("+++++++ IN! chunkCharSkipped: "+chunkCharSkipped);

      //console.log("this.numChunksInBook: "+this.numChunksInBook);
      while (chunkCharSkipped <= this.functions.numCharacterPriorOrPosterior && chunkTmp >= 0 && chunkTmp <= this.numChunksInBook) {
        chunkTmp = this.getNextChunk(chunkTmp);
        numChunkSkipped++;
        //console.log("+++++++ next chunkTmp: "+chunkTmp);
        chunkLenght = this.gamesrulesModel.getChunkLength(this.functions.getIdCurrentBook(), chunkTmp);
        //console.log("+++++++ next chunkLength: "+chunkLenght);
        if ((chunkCharSkipped + chunkLenght) > this.functions.numCharacterPriorOrPosterior) {
          // -numChunkSkipped to add a char for every chunk skipped for every chunk has a final char that is not calculated but used as one char in numCharacterPriorOrPosterior
          this.chunkCharSkippedAtBeginningOrEndOfBook = this.functions.numCharacterPriorOrPosterior - chunkCharSkipped - numChunkSkipped;
          //console.log("+++++++ chunkCharSkippedAtBeginningOrEndOfBook: "+this.chunkCharSkippedAtBeginningOrEndOfBook);
        }
        chunkCharSkipped = chunkCharSkipped + chunkLenght;
        //console.log("+++++++ next chunkCharSkipped: "+chunkCharSkipped);
      }
    }
    //console.log("+++++++ chunkTmp: "+chunkTmp);
    this.currentChunk = chunkTmp;
  }

  updateThermometer(bookmarkLetter) {
    var scoreMissed = this.gamesrulesModel.calculateScore(this.maxAttemptsWrong[this.getIndexInSlicedArray(bookmarkLetter)] + 1, this.getParOfBookmark(bookmarkLetter));
    var scoreEarnable = this.gamesrulesModel.calculateScore(1, this.getParOfBookmark(bookmarkLetter));
    this.currentThermometerColor = "#FFFFFF";
    var scoreMissedPercOverOrUnderPar;
    this.currentThermometerProgress = this.functions.calculatePercentage(scoreMissed, scoreEarnable, "scoreEarnableAndMissed");

    if (scoreMissed >= this.gamesrulesModel.scoreExactlyOnPar) {
      // over par
      this.currentBlinkingCursorColor = "green";
      scoreMissedPercOverOrUnderPar = this.functions.calculatePercentage(scoreMissed - 100, scoreEarnable - 100, "scoreEarnableAndMissed");
      if (scoreMissedPercOverOrUnderPar >= 80 && scoreMissedPercOverOrUnderPar <= 100) { this.currentThermometerColor = "#339900"; }
      if (scoreMissedPercOverOrUnderPar >= 60 && scoreMissedPercOverOrUnderPar < 80) { this.currentThermometerColor = "#33A61A"; }
      if (scoreMissedPercOverOrUnderPar >= 40 && scoreMissedPercOverOrUnderPar < 60) { this.currentThermometerColor = "#33B333"; }
      if (scoreMissedPercOverOrUnderPar >= 20 && scoreMissedPercOverOrUnderPar < 40) { this.currentThermometerColor = "#33BF4D"; }
      if (scoreMissedPercOverOrUnderPar >= 0 && scoreMissedPercOverOrUnderPar < 20) { this.currentThermometerColor = "#33CC66"; }

    } else if (scoreMissed < this.gamesrulesModel.scoreExactlyOnPar) {
      //under par
      this.currentBlinkingCursorColor = "red";
      scoreMissedPercOverOrUnderPar = this.functions.calculatePercentage(scoreMissed, 100, "scoreEarnableAndMissed");
      if (scoreMissedPercOverOrUnderPar >= 80 && scoreMissedPercOverOrUnderPar <= 100) { this.currentThermometerColor = "#FF6666 "; }
      if (scoreMissedPercOverOrUnderPar >= 60 && scoreMissedPercOverOrUnderPar < 80) { this.currentThermometerColor = "#FF4D4D "; }
      if (scoreMissedPercOverOrUnderPar >= 40 && scoreMissedPercOverOrUnderPar < 60) { this.currentThermometerColor = "#FF3333"; }
      if (scoreMissedPercOverOrUnderPar >= 20 && scoreMissedPercOverOrUnderPar < 40) { this.currentThermometerColor = "#FF1A1A"; }
      if (scoreMissedPercOverOrUnderPar >= 0 && scoreMissedPercOverOrUnderPar < 20) { this.currentThermometerColor = "#FF0000"; }
    }
    /* https://meyerweb.com/eric/tools/color-blend/#FF0000:FF99CC:4:hex */

    this.events.publish('updateThermometerColor', this.currentThermometerColor);

    /* superhappy - happy
    worried - superworried
    angry - superangry
    sad - supersad */

    if (this.currentThermometerProgress == 100) {
      if (this.mood == 'happy') {
        this.mood = 'superhappy';
      } else {
        this.mood = 'happy';
      }
    }

    if (this.currentThermometerProgress >= 80 && this.currentThermometerProgress < 100) {
      switch (this.mood) {
        case 'worried':
          this.mood = 'superworried';
          break;
        case 'superworried':
          this.mood = 'worried';
          break;
        default:
          this.mood = 'worried';
          break;
      }
    }
    if (this.currentThermometerProgress >= 60 && this.currentThermometerProgress < 80) {
      switch (this.mood) {
        case 'angry':
          this.mood = 'superworried';
          break;
        case 'superworried':
          this.mood = 'angry';
          break;
        default:
          this.mood = 'superworried';
          break;
      }
    }
    if (this.currentThermometerProgress >= 40 && this.currentThermometerProgress < 60) {
      switch (this.mood) {
        case 'angry':
          this.mood = 'superangry';
          break;
        case 'superangry':
          this.mood = 'angry';
          break;
        default:
          this.mood = 'angry';
          break;
      }
    }
    if (this.currentThermometerProgress >= 20 && this.currentThermometerProgress < 40) {
      switch (this.mood) {
        case 'sad':
          this.mood = 'superangry';
          break;
        case 'superangry':
          this.mood = 'sad';
          break;
        default:
          this.mood = 'superangry';
          break;
      }
    }

    if (this.currentThermometerProgress >= 0 && this.currentThermometerProgress < 20) {
      switch (this.mood) {
        case 'sad':
          this.mood = 'supersad';
          break;
        case 'supersad':
          this.mood = 'sad';
          break;
        default:
          this.mood = 'sad';
          break;
      }
    }
    //console.log("++++ scoreMissed: "+scoreMissed+" scoreEarnable: "+scoreEarnable);
    //console.log("++++ this.currentThermometerProgress: "+this.currentThermometerProgress+"%");
  }

  getUniqueIDCurrentKeyboardsString() {
    //console.log("++++getUniqueIDCurrentKeyboardsString: "+JSON.stringify(this.functions.keyboardsActuallyInUse[this.functions.language]));
    return this.functions.keyboardsActuallyInUse[this.functions.language];
  }
}



/*
this.initialGameDataForVersus EXAMPLE

[{
	"guidUser": "565f8e42be777",
	"username": "barbican_user_1",
	"idGame": 52,
	"idBook": 1,
	"tsBegingame": "1551716637490",
	"tsEndgame": "1551716644129",
	"language": "en",
	"scoreInitial": 274650,
	"scoreFinal": 274809,
	"parVersion": 1,
	"bookmarkLetterInitial": 1474,
	"bookmarkLetterFinal": 1475,
	"idChunkInBookInitial": 14,
	"idChunkInBookFinal": 14,
	"levelInitial": 7,
	"levelFinal": 7,
	"fartherIndexDashReachedDuringGame": 1494,
	"numCorrette": 1,
	"numSbagliate": 2,
	"priorOrPosteriorIndexes": "\"1370,1473\"",
	"giveup": 1,
	"win": "",
	"isVersus": "versusPVPAsync",
	"sent": "1551716637491",
	"accepted": "",
	"declined": "",
	"rewarded": "",
	"guidUserVersus": "bcec869df3a85",
	"usernameUserVersus": "barbican_user_2",
	"idGameVersus": "",
	"timeFinal": 5,
	"down_entropy": 1,
	"up_entropy": 1,
	"wordstyped": [{
		"guidUser": "565f8e42be777",
		"idBook": 1,
		"idGame": 52,
		"round": 0,
		"attempt": 1,
		"bookmarkLetter": 1474,
		"time": 1,
		"tsInsert": "1551716638623",
		"word": "g",
		"wordToGuess": "h",
		"isCorrect": 0,
		"scoreEarned": 0,
		"attemptsWrong": 1
	}, {
		"guidUser": "565f8e42be777",
		"idBook": 1,
		"idGame": 52,
		"round": 0,
		"attempt": 2,
		"bookmarkLetter": 1474,
		"time": 1,
		"tsInsert": "1551716639040",
		"word": "h",
		"wordToGuess": "h",
		"isCorrect": 1,
		"scoreEarned": 159,
		"attemptsWrong": 1
	}, {
		"guidUser": "565f8e42be777",
		"idBook": 1,
		"idGame": 52,
		"round": 1,
		"attempt": 3,
		"bookmarkLetter": 1475,
		"time": 3,
		"tsInsert": "1551716641343",
		"word": "f",
		"wordToGuess": "e",
		"isCorrect": 0,
		"scoreEarned": 0,
		"attemptsWrong": 1
	}]
}]

*/


// WEBPACK FOOTER //
// ./src/pages/play/play.ts